//# sourceMappingURL=ai_config.mjs.map
/// <reference types="./ai_config.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $float from "../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $weaviate from "../data/weaviate.mjs";
import * as $decrypt from "../decrypt.mjs";
import { Ok, toList, CustomType as $CustomType } from "../gleam.mjs";

export class Hybrid extends $CustomType {}
export const RetrieverOptionType$Hybrid = () => new Hybrid();
export const RetrieverOptionType$isHybrid = (value) => value instanceof Hybrid;

export class Rerank extends $CustomType {}
export const RetrieverOptionType$Rerank = () => new Rerank();
export const RetrieverOptionType$isRerank = (value) => value instanceof Rerank;

export class Fusion extends $CustomType {}
export const RetrieverOptionType$Fusion = () => new Fusion();
export const RetrieverOptionType$isFusion = (value) => value instanceof Fusion;

export class RoleOff extends $CustomType {}
export const Role$RoleOff = () => new RoleOff();
export const Role$isRoleOff = (value) => value instanceof RoleOff;

export class RoleRfpExpert extends $CustomType {}
export const Role$RoleRfpExpert = () => new RoleRfpExpert();
export const Role$isRoleRfpExpert = (value) => value instanceof RoleRfpExpert;

export class EntityMismatchOff extends $CustomType {}
export const EntityMismatch$EntityMismatchOff = () => new EntityMismatchOff();
export const EntityMismatch$isEntityMismatchOff = (value) =>
  value instanceof EntityMismatchOff;

export class EntityMismatchDefault extends $CustomType {}
export const EntityMismatch$EntityMismatchDefault = () =>
  new EntityMismatchDefault();
export const EntityMismatch$isEntityMismatchDefault = (value) =>
  value instanceof EntityMismatchDefault;

export class ApproachOff extends $CustomType {}
export const Approach$ApproachOff = () => new ApproachOff();
export const Approach$isApproachOff = (value) => value instanceof ApproachOff;

export class ApproachDefault extends $CustomType {}
export const Approach$ApproachDefault = () => new ApproachDefault();
export const Approach$isApproachDefault = (value) =>
  value instanceof ApproachDefault;

export class ToneStyleOff extends $CustomType {}
export const ToneStyle$ToneStyleOff = () => new ToneStyleOff();
export const ToneStyle$isToneStyleOff = (value) =>
  value instanceof ToneStyleOff;

export class ToneStyleDefault extends $CustomType {}
export const ToneStyle$ToneStyleDefault = () => new ToneStyleDefault();
export const ToneStyle$isToneStyleDefault = (value) =>
  value instanceof ToneStyleDefault;

export class FormattingOff extends $CustomType {}
export const Formatting$FormattingOff = () => new FormattingOff();
export const Formatting$isFormattingOff = (value) =>
  value instanceof FormattingOff;

export class FormattingDefault extends $CustomType {}
export const Formatting$FormattingDefault = () => new FormattingDefault();
export const Formatting$isFormattingDefault = (value) =>
  value instanceof FormattingDefault;

export class EvidenceOverAssertionOff extends $CustomType {}
export const EvidenceOverAssertion$EvidenceOverAssertionOff = () =>
  new EvidenceOverAssertionOff();
export const EvidenceOverAssertion$isEvidenceOverAssertionOff = (value) =>
  value instanceof EvidenceOverAssertionOff;

export class EvidenceOverAssertionDefault extends $CustomType {}
export const EvidenceOverAssertion$EvidenceOverAssertionDefault = () =>
  new EvidenceOverAssertionDefault();
export const EvidenceOverAssertion$isEvidenceOverAssertionDefault = (value) =>
  value instanceof EvidenceOverAssertionDefault;

export class RedirectOff extends $CustomType {}
export const Redirect$RedirectOff = () => new RedirectOff();
export const Redirect$isRedirectOff = (value) => value instanceof RedirectOff;

export class RedirectDefault extends $CustomType {}
export const Redirect$RedirectDefault = () => new RedirectDefault();
export const Redirect$isRedirectDefault = (value) =>
  value instanceof RedirectDefault;

export class ToneVoiceOff extends $CustomType {}
export const ToneVoice$ToneVoiceOff = () => new ToneVoiceOff();
export const ToneVoice$isToneVoiceOff = (value) =>
  value instanceof ToneVoiceOff;

export class ToneVoiceCustomer extends $CustomType {}
export const ToneVoice$ToneVoiceCustomer = () => new ToneVoiceCustomer();
export const ToneVoice$isToneVoiceCustomer = (value) =>
  value instanceof ToneVoiceCustomer;

export class ToneVoiceEngaged extends $CustomType {}
export const ToneVoice$ToneVoiceEngaged = () => new ToneVoiceEngaged();
export const ToneVoice$isToneVoiceEngaged = (value) =>
  value instanceof ToneVoiceEngaged;

export class ToneVoiceGeneric extends $CustomType {}
export const ToneVoice$ToneVoiceGeneric = () => new ToneVoiceGeneric();
export const ToneVoice$isToneVoiceGeneric = (value) =>
  value instanceof ToneVoiceGeneric;

export class RepeatQuestionOff extends $CustomType {}
export const RepeatQuestion$RepeatQuestionOff = () => new RepeatQuestionOff();
export const RepeatQuestion$isRepeatQuestionOff = (value) =>
  value instanceof RepeatQuestionOff;

export class Repeat extends $CustomType {}
export const RepeatQuestion$Repeat = () => new Repeat();
export const RepeatQuestion$isRepeat = (value) => value instanceof Repeat;

export class DoNotRepeat extends $CustomType {}
export const RepeatQuestion$DoNotRepeat = () => new DoNotRepeat();
export const RepeatQuestion$isDoNotRepeat = (value) =>
  value instanceof DoNotRepeat;

export class DoNotRepeatWarm extends $CustomType {}
export const RepeatQuestion$DoNotRepeatWarm = () => new DoNotRepeatWarm();
export const RepeatQuestion$isDoNotRepeatWarm = (value) =>
  value instanceof DoNotRepeatWarm;

export class LengthRuleOff extends $CustomType {}
export const LengthRule$LengthRuleOff = () => new LengthRuleOff();
export const LengthRule$isLengthRuleOff = (value) =>
  value instanceof LengthRuleOff;

export class CategoryBased extends $CustomType {}
export const LengthRule$CategoryBased = () => new CategoryBased();
export const LengthRule$isCategoryBased = (value) =>
  value instanceof CategoryBased;

export class Generalistic extends $CustomType {}
export const LengthRule$Generalistic = () => new Generalistic();
export const LengthRule$isGeneralistic = (value) =>
  value instanceof Generalistic;

export class WhatToReturnOff extends $CustomType {}
export const WhatToReturn$WhatToReturnOff = () => new WhatToReturnOff();
export const WhatToReturn$isWhatToReturnOff = (value) =>
  value instanceof WhatToReturnOff;

export class ReturnJson extends $CustomType {}
export const WhatToReturn$ReturnJson = () => new ReturnJson();
export const WhatToReturn$isReturnJson = (value) => value instanceof ReturnJson;

export class ReturnText extends $CustomType {}
export const WhatToReturn$ReturnText = () => new ReturnText();
export const WhatToReturn$isReturnText = (value) => value instanceof ReturnText;

export class RagModularConfig extends $CustomType {
  constructor(role, entity_mismatch, approach, tone_voice, tone_style, repeat_or_not_question, formatting, length, evidence_over_assertion, redirect, what_to_return) {
    super();
    this.role = role;
    this.entity_mismatch = entity_mismatch;
    this.approach = approach;
    this.tone_voice = tone_voice;
    this.tone_style = tone_style;
    this.repeat_or_not_question = repeat_or_not_question;
    this.formatting = formatting;
    this.length = length;
    this.evidence_over_assertion = evidence_over_assertion;
    this.redirect = redirect;
    this.what_to_return = what_to_return;
  }
}
export const RagModularConfig$RagModularConfig = (role, entity_mismatch, approach, tone_voice, tone_style, repeat_or_not_question, formatting, length, evidence_over_assertion, redirect, what_to_return) =>
  new RagModularConfig(role,
  entity_mismatch,
  approach,
  tone_voice,
  tone_style,
  repeat_or_not_question,
  formatting,
  length,
  evidence_over_assertion,
  redirect,
  what_to_return);
export const RagModularConfig$isRagModularConfig = (value) =>
  value instanceof RagModularConfig;
export const RagModularConfig$RagModularConfig$role = (value) => value.role;
export const RagModularConfig$RagModularConfig$0 = (value) => value.role;
export const RagModularConfig$RagModularConfig$entity_mismatch = (value) =>
  value.entity_mismatch;
export const RagModularConfig$RagModularConfig$1 = (value) =>
  value.entity_mismatch;
export const RagModularConfig$RagModularConfig$approach = (value) =>
  value.approach;
export const RagModularConfig$RagModularConfig$2 = (value) => value.approach;
export const RagModularConfig$RagModularConfig$tone_voice = (value) =>
  value.tone_voice;
export const RagModularConfig$RagModularConfig$3 = (value) => value.tone_voice;
export const RagModularConfig$RagModularConfig$tone_style = (value) =>
  value.tone_style;
export const RagModularConfig$RagModularConfig$4 = (value) => value.tone_style;
export const RagModularConfig$RagModularConfig$repeat_or_not_question = (value) =>
  value.repeat_or_not_question;
export const RagModularConfig$RagModularConfig$5 = (value) =>
  value.repeat_or_not_question;
export const RagModularConfig$RagModularConfig$formatting = (value) =>
  value.formatting;
export const RagModularConfig$RagModularConfig$6 = (value) => value.formatting;
export const RagModularConfig$RagModularConfig$length = (value) => value.length;
export const RagModularConfig$RagModularConfig$7 = (value) => value.length;
export const RagModularConfig$RagModularConfig$evidence_over_assertion = (value) =>
  value.evidence_over_assertion;
export const RagModularConfig$RagModularConfig$8 = (value) =>
  value.evidence_over_assertion;
export const RagModularConfig$RagModularConfig$redirect = (value) =>
  value.redirect;
export const RagModularConfig$RagModularConfig$9 = (value) => value.redirect;
export const RagModularConfig$RagModularConfig$what_to_return = (value) =>
  value.what_to_return;
export const RagModularConfig$RagModularConfig$10 = (value) =>
  value.what_to_return;

export class AzureGpt4o extends $CustomType {}
export const ModelType$AzureGpt4o = () => new AzureGpt4o();
export const ModelType$isAzureGpt4o = (value) => value instanceof AzureGpt4o;

export class AzureGpt41Mini extends $CustomType {}
export const ModelType$AzureGpt41Mini = () => new AzureGpt41Mini();
export const ModelType$isAzureGpt41Mini = (value) =>
  value instanceof AzureGpt41Mini;

export class AzureGpt5Chat extends $CustomType {}
export const ModelType$AzureGpt5Chat = () => new AzureGpt5Chat();
export const ModelType$isAzureGpt5Chat = (value) =>
  value instanceof AzureGpt5Chat;

export class AzureGpt51Chat extends $CustomType {}
export const ModelType$AzureGpt51Chat = () => new AzureGpt51Chat();
export const ModelType$isAzureGpt51Chat = (value) =>
  value instanceof AzureGpt51Chat;

export class AzureGpt5Nano extends $CustomType {}
export const ModelType$AzureGpt5Nano = () => new AzureGpt5Nano();
export const ModelType$isAzureGpt5Nano = (value) =>
  value instanceof AzureGpt5Nano;

export class AzureLlama4Scout extends $CustomType {}
export const ModelType$AzureLlama4Scout = () => new AzureLlama4Scout();
export const ModelType$isAzureLlama4Scout = (value) =>
  value instanceof AzureLlama4Scout;

export class Gpt4o extends $CustomType {}
export const ModelType$Gpt4o = () => new Gpt4o();
export const ModelType$isGpt4o = (value) => value instanceof Gpt4o;

export class Gpt41Nano extends $CustomType {}
export const ModelType$Gpt41Nano = () => new Gpt41Nano();
export const ModelType$isGpt41Nano = (value) => value instanceof Gpt41Nano;

export class Gpt41Mini extends $CustomType {}
export const ModelType$Gpt41Mini = () => new Gpt41Mini();
export const ModelType$isGpt41Mini = (value) => value instanceof Gpt41Mini;

export class Gpt41 extends $CustomType {}
export const ModelType$Gpt41 = () => new Gpt41();
export const ModelType$isGpt41 = (value) => value instanceof Gpt41;

export class Gpt5Nano extends $CustomType {}
export const ModelType$Gpt5Nano = () => new Gpt5Nano();
export const ModelType$isGpt5Nano = (value) => value instanceof Gpt5Nano;

export class Gpt5Mini extends $CustomType {}
export const ModelType$Gpt5Mini = () => new Gpt5Mini();
export const ModelType$isGpt5Mini = (value) => value instanceof Gpt5Mini;

export class Gpt5 extends $CustomType {}
export const ModelType$Gpt5 = () => new Gpt5();
export const ModelType$isGpt5 = (value) => value instanceof Gpt5;

export class Gpt5ChatLatest extends $CustomType {}
export const ModelType$Gpt5ChatLatest = () => new Gpt5ChatLatest();
export const ModelType$isGpt5ChatLatest = (value) =>
  value instanceof Gpt5ChatLatest;

export class Gpt51 extends $CustomType {}
export const ModelType$Gpt51 = () => new Gpt51();
export const ModelType$isGpt51 = (value) => value instanceof Gpt51;

export class Gpt51ChatLatest extends $CustomType {}
export const ModelType$Gpt51ChatLatest = () => new Gpt51ChatLatest();
export const ModelType$isGpt51ChatLatest = (value) =>
  value instanceof Gpt51ChatLatest;

export class Gpt52 extends $CustomType {}
export const ModelType$Gpt52 = () => new Gpt52();
export const ModelType$isGpt52 = (value) => value instanceof Gpt52;

export class Gpt52ChatLatest extends $CustomType {}
export const ModelType$Gpt52ChatLatest = () => new Gpt52ChatLatest();
export const ModelType$isGpt52ChatLatest = (value) =>
  value instanceof Gpt52ChatLatest;

export class Gpt54Nano extends $CustomType {}
export const ModelType$Gpt54Nano = () => new Gpt54Nano();
export const ModelType$isGpt54Nano = (value) => value instanceof Gpt54Nano;

export class Gpt55 extends $CustomType {}
export const ModelType$Gpt55 = () => new Gpt55();
export const ModelType$isGpt55 = (value) => value instanceof Gpt55;

export class Gpt56Sol extends $CustomType {}
export const ModelType$Gpt56Sol = () => new Gpt56Sol();
export const ModelType$isGpt56Sol = (value) => value instanceof Gpt56Sol;

export class Gpt56Terra extends $CustomType {}
export const ModelType$Gpt56Terra = () => new Gpt56Terra();
export const ModelType$isGpt56Terra = (value) => value instanceof Gpt56Terra;

export class Gpt56Luna extends $CustomType {}
export const ModelType$Gpt56Luna = () => new Gpt56Luna();
export const ModelType$isGpt56Luna = (value) => value instanceof Gpt56Luna;

export class Gpt6Astra extends $CustomType {}
export const ModelType$Gpt6Astra = () => new Gpt6Astra();
export const ModelType$isGpt6Astra = (value) => value instanceof Gpt6Astra;

export class Gpt6Sol extends $CustomType {}
export const ModelType$Gpt6Sol = () => new Gpt6Sol();
export const ModelType$isGpt6Sol = (value) => value instanceof Gpt6Sol;

export class Gpt6Luna extends $CustomType {}
export const ModelType$Gpt6Luna = () => new Gpt6Luna();
export const ModelType$isGpt6Luna = (value) => value instanceof Gpt6Luna;

export class ClaudeHaiku45 extends $CustomType {}
export const ModelType$ClaudeHaiku45 = () => new ClaudeHaiku45();
export const ModelType$isClaudeHaiku45 = (value) =>
  value instanceof ClaudeHaiku45;

export class ClaudeOpus46 extends $CustomType {}
export const ModelType$ClaudeOpus46 = () => new ClaudeOpus46();
export const ModelType$isClaudeOpus46 = (value) =>
  value instanceof ClaudeOpus46;

export class ClaudeOpus47 extends $CustomType {}
export const ModelType$ClaudeOpus47 = () => new ClaudeOpus47();
export const ModelType$isClaudeOpus47 = (value) =>
  value instanceof ClaudeOpus47;

export class ClaudeOpus48 extends $CustomType {}
export const ModelType$ClaudeOpus48 = () => new ClaudeOpus48();
export const ModelType$isClaudeOpus48 = (value) =>
  value instanceof ClaudeOpus48;

export class ClaudeOpus5 extends $CustomType {}
export const ModelType$ClaudeOpus5 = () => new ClaudeOpus5();
export const ModelType$isClaudeOpus5 = (value) => value instanceof ClaudeOpus5;

export class ClaudeSonnet46 extends $CustomType {}
export const ModelType$ClaudeSonnet46 = () => new ClaudeSonnet46();
export const ModelType$isClaudeSonnet46 = (value) =>
  value instanceof ClaudeSonnet46;

export class ClaudeSonnet5 extends $CustomType {}
export const ModelType$ClaudeSonnet5 = () => new ClaudeSonnet5();
export const ModelType$isClaudeSonnet5 = (value) =>
  value instanceof ClaudeSonnet5;

export class ClaudeFable5 extends $CustomType {}
export const ModelType$ClaudeFable5 = () => new ClaudeFable5();
export const ModelType$isClaudeFable5 = (value) =>
  value instanceof ClaudeFable5;

export class ClaudeFable51 extends $CustomType {}
export const ModelType$ClaudeFable51 = () => new ClaudeFable51();
export const ModelType$isClaudeFable51 = (value) =>
  value instanceof ClaudeFable51;

export class ClaudeOpus55 extends $CustomType {}
export const ModelType$ClaudeOpus55 = () => new ClaudeOpus55();
export const ModelType$isClaudeOpus55 = (value) =>
  value instanceof ClaudeOpus55;

export class BedrockClaude37Sonnet extends $CustomType {}
export const ModelType$BedrockClaude37Sonnet = () =>
  new BedrockClaude37Sonnet();
export const ModelType$isBedrockClaude37Sonnet = (value) =>
  value instanceof BedrockClaude37Sonnet;

export class BedrockClaudeSonnet4 extends $CustomType {}
export const ModelType$BedrockClaudeSonnet4 = () => new BedrockClaudeSonnet4();
export const ModelType$isBedrockClaudeSonnet4 = (value) =>
  value instanceof BedrockClaudeSonnet4;

export class BedrockClaudeOpus45 extends $CustomType {}
export const ModelType$BedrockClaudeOpus45 = () => new BedrockClaudeOpus45();
export const ModelType$isBedrockClaudeOpus45 = (value) =>
  value instanceof BedrockClaudeOpus45;

export class BedrockClaudeSonnet45 extends $CustomType {}
export const ModelType$BedrockClaudeSonnet45 = () =>
  new BedrockClaudeSonnet45();
export const ModelType$isBedrockClaudeSonnet45 = (value) =>
  value instanceof BedrockClaudeSonnet45;

export class BedrockClaudeHaiku45 extends $CustomType {}
export const ModelType$BedrockClaudeHaiku45 = () => new BedrockClaudeHaiku45();
export const ModelType$isBedrockClaudeHaiku45 = (value) =>
  value instanceof BedrockClaudeHaiku45;

export class BedrockClaudeSonnet46 extends $CustomType {}
export const ModelType$BedrockClaudeSonnet46 = () =>
  new BedrockClaudeSonnet46();
export const ModelType$isBedrockClaudeSonnet46 = (value) =>
  value instanceof BedrockClaudeSonnet46;

export class BedrockClaudeOpus47 extends $CustomType {}
export const ModelType$BedrockClaudeOpus47 = () => new BedrockClaudeOpus47();
export const ModelType$isBedrockClaudeOpus47 = (value) =>
  value instanceof BedrockClaudeOpus47;

export class BedrockClaudeOpus48 extends $CustomType {}
export const ModelType$BedrockClaudeOpus48 = () => new BedrockClaudeOpus48();
export const ModelType$isBedrockClaudeOpus48 = (value) =>
  value instanceof BedrockClaudeOpus48;

export class BedrockClaudeOpus5 extends $CustomType {}
export const ModelType$BedrockClaudeOpus5 = () => new BedrockClaudeOpus5();
export const ModelType$isBedrockClaudeOpus5 = (value) =>
  value instanceof BedrockClaudeOpus5;

export class BedrockClaudeSonnet5 extends $CustomType {}
export const ModelType$BedrockClaudeSonnet5 = () => new BedrockClaudeSonnet5();
export const ModelType$isBedrockClaudeSonnet5 = (value) =>
  value instanceof BedrockClaudeSonnet5;

export class BedrockDeepSeek extends $CustomType {}
export const ModelType$BedrockDeepSeek = () => new BedrockDeepSeek();
export const ModelType$isBedrockDeepSeek = (value) =>
  value instanceof BedrockDeepSeek;

export class Gemini25Flash extends $CustomType {}
export const ModelType$Gemini25Flash = () => new Gemini25Flash();
export const ModelType$isGemini25Flash = (value) =>
  value instanceof Gemini25Flash;

export class Gemini25Pro extends $CustomType {}
export const ModelType$Gemini25Pro = () => new Gemini25Pro();
export const ModelType$isGemini25Pro = (value) => value instanceof Gemini25Pro;

export class Gemini38Flash extends $CustomType {}
export const ModelType$Gemini38Flash = () => new Gemini38Flash();
export const ModelType$isGemini38Flash = (value) =>
  value instanceof Gemini38Flash;

export class Gemini37Flash extends $CustomType {}
export const ModelType$Gemini37Flash = () => new Gemini37Flash();
export const ModelType$isGemini37Flash = (value) =>
  value instanceof Gemini37Flash;

export class Gemini36Flash extends $CustomType {}
export const ModelType$Gemini36Flash = () => new Gemini36Flash();
export const ModelType$isGemini36Flash = (value) =>
  value instanceof Gemini36Flash;

export class Gemini35Flash extends $CustomType {}
export const ModelType$Gemini35Flash = () => new Gemini35Flash();
export const ModelType$isGemini35Flash = (value) =>
  value instanceof Gemini35Flash;

export class Gemini35FlashLite extends $CustomType {}
export const ModelType$Gemini35FlashLite = () => new Gemini35FlashLite();
export const ModelType$isGemini35FlashLite = (value) =>
  value instanceof Gemini35FlashLite;

export class Gemini31FlashLite extends $CustomType {}
export const ModelType$Gemini31FlashLite = () => new Gemini31FlashLite();
export const ModelType$isGemini31FlashLite = (value) =>
  value instanceof Gemini31FlashLite;

export class Gemini31ProPreview extends $CustomType {}
export const ModelType$Gemini31ProPreview = () => new Gemini31ProPreview();
export const ModelType$isGemini31ProPreview = (value) =>
  value instanceof Gemini31ProPreview;

export class AiConfig extends $CustomType {
  constructor(org_id, config) {
    super();
    this.org_id = org_id;
    this.config = config;
  }
}
export const AiConfig$AiConfig = (org_id, config) =>
  new AiConfig(org_id, config);
export const AiConfig$isAiConfig = (value) => value instanceof AiConfig;
export const AiConfig$AiConfig$org_id = (value) => value.org_id;
export const AiConfig$AiConfig$0 = (value) => value.org_id;
export const AiConfig$AiConfig$config = (value) => value.config;
export const AiConfig$AiConfig$1 = (value) => value.config;

export class Config extends $CustomType {
  constructor(style_guidelines, ai_system, llm_config, models_config, query_config, retriever_config, pii_vocabulary, context_window, llm_judge_in_the_loop, website_prompt_config, read_collection_variant, write_collection_variant, prev_write_collection_variant) {
    super();
    this.style_guidelines = style_guidelines;
    this.ai_system = ai_system;
    this.llm_config = llm_config;
    this.models_config = models_config;
    this.query_config = query_config;
    this.retriever_config = retriever_config;
    this.pii_vocabulary = pii_vocabulary;
    this.context_window = context_window;
    this.llm_judge_in_the_loop = llm_judge_in_the_loop;
    this.website_prompt_config = website_prompt_config;
    this.read_collection_variant = read_collection_variant;
    this.write_collection_variant = write_collection_variant;
    this.prev_write_collection_variant = prev_write_collection_variant;
  }
}
export const Config$Config = (style_guidelines, ai_system, llm_config, models_config, query_config, retriever_config, pii_vocabulary, context_window, llm_judge_in_the_loop, website_prompt_config, read_collection_variant, write_collection_variant, prev_write_collection_variant) =>
  new Config(style_guidelines,
  ai_system,
  llm_config,
  models_config,
  query_config,
  retriever_config,
  pii_vocabulary,
  context_window,
  llm_judge_in_the_loop,
  website_prompt_config,
  read_collection_variant,
  write_collection_variant,
  prev_write_collection_variant);
export const Config$isConfig = (value) => value instanceof Config;
export const Config$Config$style_guidelines = (value) => value.style_guidelines;
export const Config$Config$0 = (value) => value.style_guidelines;
export const Config$Config$ai_system = (value) => value.ai_system;
export const Config$Config$1 = (value) => value.ai_system;
export const Config$Config$llm_config = (value) => value.llm_config;
export const Config$Config$2 = (value) => value.llm_config;
export const Config$Config$models_config = (value) => value.models_config;
export const Config$Config$3 = (value) => value.models_config;
export const Config$Config$query_config = (value) => value.query_config;
export const Config$Config$4 = (value) => value.query_config;
export const Config$Config$retriever_config = (value) => value.retriever_config;
export const Config$Config$5 = (value) => value.retriever_config;
export const Config$Config$pii_vocabulary = (value) => value.pii_vocabulary;
export const Config$Config$6 = (value) => value.pii_vocabulary;
export const Config$Config$context_window = (value) => value.context_window;
export const Config$Config$7 = (value) => value.context_window;
export const Config$Config$llm_judge_in_the_loop = (value) =>
  value.llm_judge_in_the_loop;
export const Config$Config$8 = (value) => value.llm_judge_in_the_loop;
export const Config$Config$website_prompt_config = (value) =>
  value.website_prompt_config;
export const Config$Config$9 = (value) => value.website_prompt_config;
export const Config$Config$read_collection_variant = (value) =>
  value.read_collection_variant;
export const Config$Config$10 = (value) => value.read_collection_variant;
export const Config$Config$write_collection_variant = (value) =>
  value.write_collection_variant;
export const Config$Config$11 = (value) => value.write_collection_variant;
export const Config$Config$prev_write_collection_variant = (value) =>
  value.prev_write_collection_variant;
export const Config$Config$12 = (value) => value.prev_write_collection_variant;

export class NaiveRag extends $CustomType {}
export const AiSystem$NaiveRag = () => new NaiveRag();
export const AiSystem$isNaiveRag = (value) => value instanceof NaiveRag;

export class AdvancedRag extends $CustomType {}
export const AiSystem$AdvancedRag = () => new AdvancedRag();
export const AiSystem$isAdvancedRag = (value) => value instanceof AdvancedRag;

export class AgenticRag extends $CustomType {}
export const AiSystem$AgenticRag = () => new AgenticRag();
export const AiSystem$isAgenticRag = (value) => value instanceof AgenticRag;

export class LlmEnhancedVectorSearch extends $CustomType {}
export const AiSystem$LlmEnhancedVectorSearch = () =>
  new LlmEnhancedVectorSearch();
export const AiSystem$isLlmEnhancedVectorSearch = (value) =>
  value instanceof LlmEnhancedVectorSearch;

export class QuestionAnswerV1 extends $CustomType {}
export const RagPrompt$QuestionAnswerV1 = () => new QuestionAnswerV1();
export const RagPrompt$isQuestionAnswerV1 = (value) =>
  value instanceof QuestionAnswerV1;

export class QuestionAnswerV2 extends $CustomType {}
export const RagPrompt$QuestionAnswerV2 = () => new QuestionAnswerV2();
export const RagPrompt$isQuestionAnswerV2 = (value) =>
  value instanceof QuestionAnswerV2;

export class AssessRequirementV1 extends $CustomType {}
export const RagPrompt$AssessRequirementV1 = () => new AssessRequirementV1();
export const RagPrompt$isAssessRequirementV1 = (value) =>
  value instanceof AssessRequirementV1;

export class AssessRequirementV2 extends $CustomType {}
export const RagPrompt$AssessRequirementV2 = () => new AssessRequirementV2();
export const RagPrompt$isAssessRequirementV2 = (value) =>
  value instanceof AssessRequirementV2;

export class Modular extends $CustomType {}
export const RagPrompt$Modular = () => new Modular();
export const RagPrompt$isModular = (value) => value instanceof Modular;

export class ReasoningLow extends $CustomType {}
export const ReasoningEffort$ReasoningLow = () => new ReasoningLow();
export const ReasoningEffort$isReasoningLow = (value) =>
  value instanceof ReasoningLow;

export class ReasoningMedium extends $CustomType {}
export const ReasoningEffort$ReasoningMedium = () => new ReasoningMedium();
export const ReasoningEffort$isReasoningMedium = (value) =>
  value instanceof ReasoningMedium;

export class ReasoningHigh extends $CustomType {}
export const ReasoningEffort$ReasoningHigh = () => new ReasoningHigh();
export const ReasoningEffort$isReasoningHigh = (value) =>
  value instanceof ReasoningHigh;

export class VerbosityLow extends $CustomType {}
export const Verbosity$VerbosityLow = () => new VerbosityLow();
export const Verbosity$isVerbosityLow = (value) =>
  value instanceof VerbosityLow;

export class VerbosityMedium extends $CustomType {}
export const Verbosity$VerbosityMedium = () => new VerbosityMedium();
export const Verbosity$isVerbosityMedium = (value) =>
  value instanceof VerbosityMedium;

export class VerbosityHigh extends $CustomType {}
export const Verbosity$VerbosityHigh = () => new VerbosityHigh();
export const Verbosity$isVerbosityHigh = (value) =>
  value instanceof VerbosityHigh;

export class ComputeScoreV1 extends $CustomType {}
export const ScorePrompt$ComputeScoreV1 = () => new ComputeScoreV1();
export const ScorePrompt$isComputeScoreV1 = (value) =>
  value instanceof ComputeScoreV1;

export class ComputeScoreV2 extends $CustomType {}
export const ScorePrompt$ComputeScoreV2 = () => new ComputeScoreV2();
export const ScorePrompt$isComputeScoreV2 = (value) =>
  value instanceof ComputeScoreV2;

export class LLMConfig extends $CustomType {
  constructor(limit) {
    super();
    this.limit = limit;
  }
}
export const LLMConfig$LLMConfig = (limit) => new LLMConfig(limit);
export const LLMConfig$isLLMConfig = (value) => value instanceof LLMConfig;
export const LLMConfig$LLMConfig$limit = (value) => value.limit;
export const LLMConfig$LLMConfig$0 = (value) => value.limit;

export class ModelsConfig extends $CustomType {
  constructor(rag, rag_temperature, rag_prompt, rag_modular_config, rag_structured_call, run_style_prompt, convert_markdown_to_html, reasoning_effort, verbosity, compute_score_prompt, style_2, summary, classifier, translate_model, conversational_model, eval_model, default_model, website_scrapping_model, search_model, rows_columns_detection_model, advanced_cell_detection_model, docx_question_detection_model, website_capture_model, answer_instruction_model, agentic_loop_driver_model, default_fallback_models) {
    super();
    this.rag = rag;
    this.rag_temperature = rag_temperature;
    this.rag_prompt = rag_prompt;
    this.rag_modular_config = rag_modular_config;
    this.rag_structured_call = rag_structured_call;
    this.run_style_prompt = run_style_prompt;
    this.convert_markdown_to_html = convert_markdown_to_html;
    this.reasoning_effort = reasoning_effort;
    this.verbosity = verbosity;
    this.compute_score_prompt = compute_score_prompt;
    this.style_2 = style_2;
    this.summary = summary;
    this.classifier = classifier;
    this.translate_model = translate_model;
    this.conversational_model = conversational_model;
    this.eval_model = eval_model;
    this.default_model = default_model;
    this.website_scrapping_model = website_scrapping_model;
    this.search_model = search_model;
    this.rows_columns_detection_model = rows_columns_detection_model;
    this.advanced_cell_detection_model = advanced_cell_detection_model;
    this.docx_question_detection_model = docx_question_detection_model;
    this.website_capture_model = website_capture_model;
    this.answer_instruction_model = answer_instruction_model;
    this.agentic_loop_driver_model = agentic_loop_driver_model;
    this.default_fallback_models = default_fallback_models;
  }
}
export const ModelsConfig$ModelsConfig = (rag, rag_temperature, rag_prompt, rag_modular_config, rag_structured_call, run_style_prompt, convert_markdown_to_html, reasoning_effort, verbosity, compute_score_prompt, style_2, summary, classifier, translate_model, conversational_model, eval_model, default_model, website_scrapping_model, search_model, rows_columns_detection_model, advanced_cell_detection_model, docx_question_detection_model, website_capture_model, answer_instruction_model, agentic_loop_driver_model, default_fallback_models) =>
  new ModelsConfig(rag,
  rag_temperature,
  rag_prompt,
  rag_modular_config,
  rag_structured_call,
  run_style_prompt,
  convert_markdown_to_html,
  reasoning_effort,
  verbosity,
  compute_score_prompt,
  style_2,
  summary,
  classifier,
  translate_model,
  conversational_model,
  eval_model,
  default_model,
  website_scrapping_model,
  search_model,
  rows_columns_detection_model,
  advanced_cell_detection_model,
  docx_question_detection_model,
  website_capture_model,
  answer_instruction_model,
  agentic_loop_driver_model,
  default_fallback_models);
export const ModelsConfig$isModelsConfig = (value) =>
  value instanceof ModelsConfig;
export const ModelsConfig$ModelsConfig$rag = (value) => value.rag;
export const ModelsConfig$ModelsConfig$0 = (value) => value.rag;
export const ModelsConfig$ModelsConfig$rag_temperature = (value) =>
  value.rag_temperature;
export const ModelsConfig$ModelsConfig$1 = (value) => value.rag_temperature;
export const ModelsConfig$ModelsConfig$rag_prompt = (value) => value.rag_prompt;
export const ModelsConfig$ModelsConfig$2 = (value) => value.rag_prompt;
export const ModelsConfig$ModelsConfig$rag_modular_config = (value) =>
  value.rag_modular_config;
export const ModelsConfig$ModelsConfig$3 = (value) => value.rag_modular_config;
export const ModelsConfig$ModelsConfig$rag_structured_call = (value) =>
  value.rag_structured_call;
export const ModelsConfig$ModelsConfig$4 = (value) => value.rag_structured_call;
export const ModelsConfig$ModelsConfig$run_style_prompt = (value) =>
  value.run_style_prompt;
export const ModelsConfig$ModelsConfig$5 = (value) => value.run_style_prompt;
export const ModelsConfig$ModelsConfig$convert_markdown_to_html = (value) =>
  value.convert_markdown_to_html;
export const ModelsConfig$ModelsConfig$6 = (value) =>
  value.convert_markdown_to_html;
export const ModelsConfig$ModelsConfig$reasoning_effort = (value) =>
  value.reasoning_effort;
export const ModelsConfig$ModelsConfig$7 = (value) => value.reasoning_effort;
export const ModelsConfig$ModelsConfig$verbosity = (value) => value.verbosity;
export const ModelsConfig$ModelsConfig$8 = (value) => value.verbosity;
export const ModelsConfig$ModelsConfig$compute_score_prompt = (value) =>
  value.compute_score_prompt;
export const ModelsConfig$ModelsConfig$9 = (value) =>
  value.compute_score_prompt;
export const ModelsConfig$ModelsConfig$style_2 = (value) => value.style_2;
export const ModelsConfig$ModelsConfig$10 = (value) => value.style_2;
export const ModelsConfig$ModelsConfig$summary = (value) => value.summary;
export const ModelsConfig$ModelsConfig$11 = (value) => value.summary;
export const ModelsConfig$ModelsConfig$classifier = (value) => value.classifier;
export const ModelsConfig$ModelsConfig$12 = (value) => value.classifier;
export const ModelsConfig$ModelsConfig$translate_model = (value) =>
  value.translate_model;
export const ModelsConfig$ModelsConfig$13 = (value) => value.translate_model;
export const ModelsConfig$ModelsConfig$conversational_model = (value) =>
  value.conversational_model;
export const ModelsConfig$ModelsConfig$14 = (value) =>
  value.conversational_model;
export const ModelsConfig$ModelsConfig$eval_model = (value) => value.eval_model;
export const ModelsConfig$ModelsConfig$15 = (value) => value.eval_model;
export const ModelsConfig$ModelsConfig$default_model = (value) =>
  value.default_model;
export const ModelsConfig$ModelsConfig$16 = (value) => value.default_model;
export const ModelsConfig$ModelsConfig$website_scrapping_model = (value) =>
  value.website_scrapping_model;
export const ModelsConfig$ModelsConfig$17 = (value) =>
  value.website_scrapping_model;
export const ModelsConfig$ModelsConfig$search_model = (value) =>
  value.search_model;
export const ModelsConfig$ModelsConfig$18 = (value) => value.search_model;
export const ModelsConfig$ModelsConfig$rows_columns_detection_model = (value) =>
  value.rows_columns_detection_model;
export const ModelsConfig$ModelsConfig$19 = (value) =>
  value.rows_columns_detection_model;
export const ModelsConfig$ModelsConfig$advanced_cell_detection_model = (value) =>
  value.advanced_cell_detection_model;
export const ModelsConfig$ModelsConfig$20 = (value) =>
  value.advanced_cell_detection_model;
export const ModelsConfig$ModelsConfig$docx_question_detection_model = (value) =>
  value.docx_question_detection_model;
export const ModelsConfig$ModelsConfig$21 = (value) =>
  value.docx_question_detection_model;
export const ModelsConfig$ModelsConfig$website_capture_model = (value) =>
  value.website_capture_model;
export const ModelsConfig$ModelsConfig$22 = (value) =>
  value.website_capture_model;
export const ModelsConfig$ModelsConfig$answer_instruction_model = (value) =>
  value.answer_instruction_model;
export const ModelsConfig$ModelsConfig$23 = (value) =>
  value.answer_instruction_model;
export const ModelsConfig$ModelsConfig$agentic_loop_driver_model = (value) =>
  value.agentic_loop_driver_model;
export const ModelsConfig$ModelsConfig$24 = (value) =>
  value.agentic_loop_driver_model;
export const ModelsConfig$ModelsConfig$default_fallback_models = (value) =>
  value.default_fallback_models;
export const ModelsConfig$ModelsConfig$25 = (value) =>
  value.default_fallback_models;

export class AgenticRetrievalConfig extends $CustomType {
  constructor(max_iterations, max_docs, max_queries) {
    super();
    this.max_iterations = max_iterations;
    this.max_docs = max_docs;
    this.max_queries = max_queries;
  }
}
export const AgenticRetrievalConfig$AgenticRetrievalConfig = (max_iterations, max_docs, max_queries) =>
  new AgenticRetrievalConfig(max_iterations, max_docs, max_queries);
export const AgenticRetrievalConfig$isAgenticRetrievalConfig = (value) =>
  value instanceof AgenticRetrievalConfig;
export const AgenticRetrievalConfig$AgenticRetrievalConfig$max_iterations = (value) =>
  value.max_iterations;
export const AgenticRetrievalConfig$AgenticRetrievalConfig$0 = (value) =>
  value.max_iterations;
export const AgenticRetrievalConfig$AgenticRetrievalConfig$max_docs = (value) =>
  value.max_docs;
export const AgenticRetrievalConfig$AgenticRetrievalConfig$1 = (value) =>
  value.max_docs;
export const AgenticRetrievalConfig$AgenticRetrievalConfig$max_queries = (value) =>
  value.max_queries;
export const AgenticRetrievalConfig$AgenticRetrievalConfig$2 = (value) =>
  value.max_queries;

export class QueryConfig extends $CustomType {
  constructor(limit, alpha, parent_lookup, hyde, extract_question, minimal_score, split_query, use_dates, agentic_retrieval) {
    super();
    this.limit = limit;
    this.alpha = alpha;
    this.parent_lookup = parent_lookup;
    this.hyde = hyde;
    this.extract_question = extract_question;
    this.minimal_score = minimal_score;
    this.split_query = split_query;
    this.use_dates = use_dates;
    this.agentic_retrieval = agentic_retrieval;
  }
}
export const QueryConfig$QueryConfig = (limit, alpha, parent_lookup, hyde, extract_question, minimal_score, split_query, use_dates, agentic_retrieval) =>
  new QueryConfig(limit,
  alpha,
  parent_lookup,
  hyde,
  extract_question,
  minimal_score,
  split_query,
  use_dates,
  agentic_retrieval);
export const QueryConfig$isQueryConfig = (value) =>
  value instanceof QueryConfig;
export const QueryConfig$QueryConfig$limit = (value) => value.limit;
export const QueryConfig$QueryConfig$0 = (value) => value.limit;
export const QueryConfig$QueryConfig$alpha = (value) => value.alpha;
export const QueryConfig$QueryConfig$1 = (value) => value.alpha;
export const QueryConfig$QueryConfig$parent_lookup = (value) =>
  value.parent_lookup;
export const QueryConfig$QueryConfig$2 = (value) => value.parent_lookup;
export const QueryConfig$QueryConfig$hyde = (value) => value.hyde;
export const QueryConfig$QueryConfig$3 = (value) => value.hyde;
export const QueryConfig$QueryConfig$extract_question = (value) =>
  value.extract_question;
export const QueryConfig$QueryConfig$4 = (value) => value.extract_question;
export const QueryConfig$QueryConfig$minimal_score = (value) =>
  value.minimal_score;
export const QueryConfig$QueryConfig$5 = (value) => value.minimal_score;
export const QueryConfig$QueryConfig$split_query = (value) => value.split_query;
export const QueryConfig$QueryConfig$6 = (value) => value.split_query;
export const QueryConfig$QueryConfig$use_dates = (value) => value.use_dates;
export const QueryConfig$QueryConfig$7 = (value) => value.use_dates;
export const QueryConfig$QueryConfig$agentic_retrieval = (value) =>
  value.agentic_retrieval;
export const QueryConfig$QueryConfig$8 = (value) => value.agentic_retrieval;

export class RetrieverConfig extends $CustomType {
  constructor(option) {
    super();
    this.option = option;
  }
}
export const RetrieverConfig$RetrieverConfig = (option) =>
  new RetrieverConfig(option);
export const RetrieverConfig$isRetrieverConfig = (value) =>
  value instanceof RetrieverConfig;
export const RetrieverConfig$RetrieverConfig$option = (value) => value.option;
export const RetrieverConfig$RetrieverConfig$0 = (value) => value.option;

export class ContextWindow extends $CustomType {
  constructor(lookback, lookahead) {
    super();
    this.lookback = lookback;
    this.lookahead = lookahead;
  }
}
export const ContextWindow$ContextWindow = (lookback, lookahead) =>
  new ContextWindow(lookback, lookahead);
export const ContextWindow$isContextWindow = (value) =>
  value instanceof ContextWindow;
export const ContextWindow$ContextWindow$lookback = (value) => value.lookback;
export const ContextWindow$ContextWindow$0 = (value) => value.lookback;
export const ContextWindow$ContextWindow$lookahead = (value) => value.lookahead;
export const ContextWindow$ContextWindow$1 = (value) => value.lookahead;

export class WebsitePromptConfig extends $CustomType {
  constructor(labels_instructions, what_to_ignore, breadcrumbs_instructions) {
    super();
    this.labels_instructions = labels_instructions;
    this.what_to_ignore = what_to_ignore;
    this.breadcrumbs_instructions = breadcrumbs_instructions;
  }
}
export const WebsitePromptConfig$WebsitePromptConfig = (labels_instructions, what_to_ignore, breadcrumbs_instructions) =>
  new WebsitePromptConfig(labels_instructions,
  what_to_ignore,
  breadcrumbs_instructions);
export const WebsitePromptConfig$isWebsitePromptConfig = (value) =>
  value instanceof WebsitePromptConfig;
export const WebsitePromptConfig$WebsitePromptConfig$labels_instructions = (value) =>
  value.labels_instructions;
export const WebsitePromptConfig$WebsitePromptConfig$0 = (value) =>
  value.labels_instructions;
export const WebsitePromptConfig$WebsitePromptConfig$what_to_ignore = (value) =>
  value.what_to_ignore;
export const WebsitePromptConfig$WebsitePromptConfig$1 = (value) =>
  value.what_to_ignore;
export const WebsitePromptConfig$WebsitePromptConfig$breadcrumbs_instructions = (value) =>
  value.breadcrumbs_instructions;
export const WebsitePromptConfig$WebsitePromptConfig$2 = (value) =>
  value.breadcrumbs_instructions;

const breadcrumbs_instructions_default = "Extract the page's section hierarchy (breadcrumbs) using the following signals, in order of priority:\n1. JSON-LD structured data — look for <script type=\"application/ld+json\"> containing \"@type\": \"BreadcrumbList\". Extract the name of each itemListElement in order, excluding \"Home\".\n2. Open Graph / meta tags — check for <meta property=\"article:section\"> or <meta name=\"category\">.\n3. Visible breadcrumb nav — look for <nav aria-label=\"breadcrumb\">, <ol class=\"breadcrumb\">, or any element with \"breadcrumb\" in its class/id. Extract the visible link text in order, excluding \"Home\".\n4. URL path — fall back to splitting the URL path into segments (e.g. /blog/tutorials/my-post → [\"blog\", \"tutorials\"]).\n\nReturn the result as a list of strings from most general to most specific, e.g. [\"Blog\", \"Tutorials\"]. If none of the above yield useful results, return an empty list.";

const what_to_ignore_default = "- Header menus and top navigation\n- Footer (Terms, Privacy, Copyright, Cookie policy)\n- Sidebar widgets unrelated to the main content zone\n- Login / signup buttons\n- Social media links\n- Cookie banners and promotional popups\n- Language selector links";

const label_instructions_default = "Tags are usually related to a product name or service name.\nLook for it in various parts of the website, usually before the beginning of the main content.\nSometimes on the side panel of the content.";

export const default_deactivated_context_window_lookahead = 0;

export const default_deactivated_context_window_lookback = 0;

export const default_activated_context_window_lookback = 5;

export const systems = /* @__PURE__ */ toList([
  /* @__PURE__ */ new NaiveRag(),
  /* @__PURE__ */ new AdvancedRag(),
  /* @__PURE__ */ new AgenticRag(),
  /* @__PURE__ */ new LlmEnhancedVectorSearch(),
]);

export const rag_prompts = /* @__PURE__ */ toList([
  /* @__PURE__ */ new QuestionAnswerV1(),
  /* @__PURE__ */ new QuestionAnswerV2(),
  /* @__PURE__ */ new AssessRequirementV1(),
  /* @__PURE__ */ new AssessRequirementV2(),
  /* @__PURE__ */ new Modular(),
]);

export const score_prompts = /* @__PURE__ */ toList([
  /* @__PURE__ */ new ComputeScoreV1(),
  /* @__PURE__ */ new ComputeScoreV2(),
]);

export const retriever_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new Hybrid(),
  /* @__PURE__ */ new Rerank(),
  /* @__PURE__ */ new Fusion(),
]);

export const reasoning_effort_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new None(),
  /* @__PURE__ */ new Some(/* @__PURE__ */ new ReasoningLow()),
  /* @__PURE__ */ new Some(/* @__PURE__ */ new ReasoningMedium()),
  /* @__PURE__ */ new Some(/* @__PURE__ */ new ReasoningHigh()),
]);

export const verbosity_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new None(),
  /* @__PURE__ */ new Some(/* @__PURE__ */ new VerbosityLow()),
  /* @__PURE__ */ new Some(/* @__PURE__ */ new VerbosityMedium()),
  /* @__PURE__ */ new Some(/* @__PURE__ */ new VerbosityHigh()),
]);

export const role_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new RoleOff(),
  /* @__PURE__ */ new RoleRfpExpert(),
]);

export const entity_mismatch_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new EntityMismatchOff(),
  /* @__PURE__ */ new EntityMismatchDefault(),
]);

export const approach_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new ApproachOff(),
  /* @__PURE__ */ new ApproachDefault(),
]);

export const tone_style_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new ToneStyleOff(),
  /* @__PURE__ */ new ToneStyleDefault(),
]);

export const formatting_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new FormattingOff(),
  /* @__PURE__ */ new FormattingDefault(),
]);

export const evidence_over_assertion_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new EvidenceOverAssertionOff(),
  /* @__PURE__ */ new EvidenceOverAssertionDefault(),
]);

export const redirect_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new RedirectOff(),
  /* @__PURE__ */ new RedirectDefault(),
]);

export const tone_voice_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new ToneVoiceOff(),
  /* @__PURE__ */ new ToneVoiceCustomer(),
  /* @__PURE__ */ new ToneVoiceEngaged(),
  /* @__PURE__ */ new ToneVoiceGeneric(),
]);

export const repeat_question_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new RepeatQuestionOff(),
  /* @__PURE__ */ new Repeat(),
  /* @__PURE__ */ new DoNotRepeat(),
  /* @__PURE__ */ new DoNotRepeatWarm(),
]);

export const length_rule_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new LengthRuleOff(),
  /* @__PURE__ */ new CategoryBased(),
  /* @__PURE__ */ new Generalistic(),
]);

export const what_to_return_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new WhatToReturnOff(),
  /* @__PURE__ */ new ReturnJson(),
  /* @__PURE__ */ new ReturnText(),
]);

/**
 * Models offered in the UI. Retired models stay in `ModelType` so stored
 * configs still decode to what they actually name, but are left out of this
 * list; re-enabling one means adding it back here and to nabu's registry.
 */
export const all_models = /* @__PURE__ */ toList([
  /* @__PURE__ */ new AzureGpt4o(),
  /* @__PURE__ */ new AzureGpt41Mini(),
  /* @__PURE__ */ new Gpt4o(),
  /* @__PURE__ */ new Gpt41Nano(),
  /* @__PURE__ */ new Gpt41Mini(),
  /* @__PURE__ */ new Gpt41(),
  /* @__PURE__ */ new Gpt5Nano(),
  /* @__PURE__ */ new Gpt5Mini(),
  /* @__PURE__ */ new Gpt5(),
  /* @__PURE__ */ new Gpt51(),
  /* @__PURE__ */ new Gpt52(),
  /* @__PURE__ */ new Gpt54Nano(),
  /* @__PURE__ */ new Gpt55(),
  /* @__PURE__ */ new Gpt56Sol(),
  /* @__PURE__ */ new Gpt56Terra(),
  /* @__PURE__ */ new Gpt56Luna(),
  /* @__PURE__ */ new Gpt6Astra(),
  /* @__PURE__ */ new Gpt6Sol(),
  /* @__PURE__ */ new Gpt6Luna(),
  /* @__PURE__ */ new ClaudeHaiku45(),
  /* @__PURE__ */ new ClaudeOpus46(),
  /* @__PURE__ */ new ClaudeOpus47(),
  /* @__PURE__ */ new ClaudeOpus48(),
  /* @__PURE__ */ new ClaudeOpus5(),
  /* @__PURE__ */ new ClaudeSonnet46(),
  /* @__PURE__ */ new ClaudeSonnet5(),
  /* @__PURE__ */ new ClaudeFable5(),
  /* @__PURE__ */ new ClaudeFable51(),
  /* @__PURE__ */ new ClaudeOpus55(),
  /* @__PURE__ */ new BedrockClaudeOpus45(),
  /* @__PURE__ */ new BedrockClaudeSonnet45(),
  /* @__PURE__ */ new BedrockClaudeHaiku45(),
  /* @__PURE__ */ new BedrockClaudeSonnet46(),
  /* @__PURE__ */ new BedrockClaudeOpus47(),
  /* @__PURE__ */ new BedrockClaudeOpus48(),
  /* @__PURE__ */ new BedrockClaudeOpus5(),
  /* @__PURE__ */ new BedrockClaudeSonnet5(),
  /* @__PURE__ */ new BedrockDeepSeek(),
  /* @__PURE__ */ new Gemini25Flash(),
  /* @__PURE__ */ new Gemini25Pro(),
  /* @__PURE__ */ new Gemini38Flash(),
  /* @__PURE__ */ new Gemini37Flash(),
  /* @__PURE__ */ new Gemini36Flash(),
  /* @__PURE__ */ new Gemini35Flash(),
  /* @__PURE__ */ new Gemini35FlashLite(),
  /* @__PURE__ */ new Gemini31FlashLite(),
  /* @__PURE__ */ new Gemini31ProPreview(),
]);

function default_website_prompt_config() {
  return new WebsitePromptConfig(
    label_instructions_default,
    what_to_ignore_default,
    breadcrumbs_instructions_default,
  );
}

function website_prompt_config_decoder() {
  return $decrypt.optional_field(
    "labels_instructions",
    $decode.string,
    (labels_instructions) => {
      let labels_instructions$1 = $option.unwrap(
        labels_instructions,
        label_instructions_default,
      );
      return $decrypt.optional_field(
        "what_to_ignore",
        $decode.string,
        (what_to_ignore) => {
          let what_to_ignore$1 = $option.unwrap(
            what_to_ignore,
            what_to_ignore_default,
          );
          return $decrypt.optional_field(
            "breadcrumbs_instructions",
            $decode.string,
            (breadcrumbs_instructions) => {
              let breadcrumbs_instructions$1 = $option.unwrap(
                breadcrumbs_instructions,
                breadcrumbs_instructions_default,
              );
              return $decode.success(
                new WebsitePromptConfig(
                  labels_instructions$1,
                  what_to_ignore$1,
                  breadcrumbs_instructions$1,
                ),
              );
            },
          );
        },
      );
    },
  );
}

function context_window_decoder() {
  return $decode.field(
    "lookback",
    $decode.int,
    (lookback) => {
      return $decode.field(
        "lookahead",
        $decode.int,
        (lookahead) => {
          return $decode.success(new ContextWindow(lookback, lookahead));
        },
      );
    },
  );
}

function retriever_option_type_decoder() {
  return $decode.then$(
    $decode.string,
    (option) => {
      let expected = "hybrid | rerank | fusion";
      if (option === "hybrid") {
        return $decode.success(new Hybrid());
      } else if (option === "rerank") {
        return $decode.success(new Rerank());
      } else if (option === "fusion") {
        return $decode.success(new Fusion());
      } else {
        return $decode.failure(new Hybrid(), expected);
      }
    },
  );
}

function retriever_config_decoder() {
  return $decode.field(
    "option",
    retriever_option_type_decoder(),
    (option) => { return $decode.success(new RetrieverConfig(option)); },
  );
}

function agentic_retrieval_decoder() {
  return $decode.field(
    "max_iterations",
    $decode.int,
    (max_iterations) => {
      return $decode.field(
        "max_docs",
        $decode.int,
        (max_docs) => {
          return $decode.field(
            "max_queries",
            $decode.int,
            (max_queries) => {
              return $decode.success(
                new AgenticRetrievalConfig(
                  max_iterations,
                  max_docs,
                  max_queries,
                ),
              );
            },
          );
        },
      );
    },
  );
}

function query_config_decoder() {
  return $decode.field(
    "limit",
    $decode.int,
    (limit) => {
      return $decode.field(
        "alpha",
        $decrypt.float(),
        (alpha) => {
          return $decode.field(
            "parent_lookup",
            $decode.bool,
            (parent_lookup) => {
              return $decode.field(
                "hyde",
                $decode.bool,
                (hyde) => {
                  return $decode.field(
                    "extract_question",
                    $decode.bool,
                    (extract_question) => {
                      return $decode.field(
                        "minimal_score",
                        $decode.one_of(
                          $decode.float,
                          toList([$decode.map($decode.int, $int.to_float)]),
                        ),
                        (minimal_score) => {
                          return $decode.field(
                            "split_query",
                            $decode.bool,
                            (split_query) => {
                              return $decrypt.optional_field(
                                "use_dates",
                                $decode.bool,
                                (use_dates) => {
                                  return $decrypt.optional_field(
                                    "agentic_retrieval",
                                    agentic_retrieval_decoder(),
                                    (agentic_retrieval) => {
                                      let use_dates$1 = $option.unwrap(
                                        use_dates,
                                        false,
                                      );
                                      return $decode.success(
                                        new QueryConfig(
                                          limit,
                                          alpha,
                                          parent_lookup,
                                          hyde,
                                          extract_question,
                                          minimal_score,
                                          split_query,
                                          use_dates$1,
                                          agentic_retrieval,
                                        ),
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function model_decoder() {
  return $decode.then$(
    $decode.string,
    (option) => {
      let expected = "azure/azure-gpt-4o";
      if (option === "azure/azure-gpt-4o") {
        return $decode.success(new AzureGpt4o());
      } else if (option === "azure/gpt-4.1-mini") {
        return $decode.success(new AzureGpt41Mini());
      } else if (option === "azure_ai/gpt-5-chat") {
        return $decode.success(new AzureGpt5Chat());
      } else if (option === "azure_ai/gpt-5.1-chat") {
        return $decode.success(new AzureGpt51Chat());
      } else if (option === "azure_ai/gpt-5-nano") {
        return $decode.success(new AzureGpt5Nano());
      } else if (option === "azure_ai/Llama-4-Scout-17B-16E-Instruct") {
        return $decode.success(new AzureLlama4Scout());
      } else if (option === "openai/gpt-4o") {
        return $decode.success(new Gpt4o());
      } else if (option === "openai/gpt-4.1-nano") {
        return $decode.success(new Gpt41Nano());
      } else if (option === "openai/gpt-4.1-mini") {
        return $decode.success(new Gpt41Mini());
      } else if (option === "openai/gpt-4.1") {
        return $decode.success(new Gpt41());
      } else if (option === "openai/gpt-5-nano") {
        return $decode.success(new Gpt5Nano());
      } else if (option === "openai/gpt-5-mini") {
        return $decode.success(new Gpt5Mini());
      } else if (option === "openai/gpt-5") {
        return $decode.success(new Gpt5());
      } else if (option === "openai/gpt-5-chat-latest") {
        return $decode.success(new Gpt5ChatLatest());
      } else if (option === "openai/gpt-5.1") {
        return $decode.success(new Gpt51());
      } else if (option === "openai/gpt-5.1-chat-latest") {
        return $decode.success(new Gpt51ChatLatest());
      } else if (option === "openai/gpt-5.2") {
        return $decode.success(new Gpt52());
      } else if (option === "openai/gpt-5.2-chat-latest") {
        return $decode.success(new Gpt52ChatLatest());
      } else if (option === "openai/gpt-5.4-nano") {
        return $decode.success(new Gpt54Nano());
      } else if (option === "openai/gpt-5.5") {
        return $decode.success(new Gpt55());
      } else if (option === "openai/gpt-5.6-sol") {
        return $decode.success(new Gpt56Sol());
      } else if (option === "openai/gpt-5.6-terra") {
        return $decode.success(new Gpt56Terra());
      } else if (option === "openai/gpt-5.6-luna") {
        return $decode.success(new Gpt56Luna());
      } else if (option === "openai/gpt-6-astra") {
        return $decode.success(new Gpt6Astra());
      } else if (option === "openai/gpt-6-sol") {
        return $decode.success(new Gpt6Sol());
      } else if (option === "openai/gpt-6-luna") {
        return $decode.success(new Gpt6Luna());
      } else if (option === "claude-haiku-4-5-20251001") {
        return $decode.success(new ClaudeHaiku45());
      } else if (option === "claude-opus-4-6") {
        return $decode.success(new ClaudeOpus46());
      } else if (option === "claude-opus-4-7") {
        return $decode.success(new ClaudeOpus47());
      } else if (option === "claude-opus-4-8") {
        return $decode.success(new ClaudeOpus48());
      } else if (option === "claude-opus-5") {
        return $decode.success(new ClaudeOpus5());
      } else if (option === "claude-sonnet-4-6") {
        return $decode.success(new ClaudeSonnet46());
      } else if (option === "claude-sonnet-5") {
        return $decode.success(new ClaudeSonnet5());
      } else if (option === "claude-fable-5") {
        return $decode.success(new ClaudeFable5());
      } else if (option === "claude-fable-5-1") {
        return $decode.success(new ClaudeFable51());
      } else if (option === "claude-opus-5-5") {
        return $decode.success(new ClaudeOpus55());
      } else if (
        option === "bedrock/eu.anthropic.claude-3-7-sonnet-20250219-v1:0"
      ) {
        return $decode.success(new BedrockClaude37Sonnet());
      } else if (option === "bedrock/eu.anthropic.claude-sonnet-4-20250514-v1:0") {
        return $decode.success(new BedrockClaudeSonnet4());
      } else if (option === "bedrock/eu.anthropic.claude-opus-4-5-20251101-v1:0") {
        return $decode.success(new BedrockClaudeOpus45());
      } else if (
        option === "bedrock/eu.anthropic.claude-sonnet-4-5-20250929-v1:0"
      ) {
        return $decode.success(new BedrockClaudeSonnet45());
      } else if (
        option === "bedrock/eu.anthropic.claude-haiku-4-5-20251001-v1:0"
      ) {
        return $decode.success(new BedrockClaudeHaiku45());
      } else if (option === "bedrock/eu.anthropic.claude-sonnet-4-6") {
        return $decode.success(new BedrockClaudeSonnet46());
      } else if (option === "bedrock/eu.anthropic.claude-opus-4-7") {
        return $decode.success(new BedrockClaudeOpus47());
      } else if (option === "bedrock/eu.anthropic.claude-opus-4-8") {
        return $decode.success(new BedrockClaudeOpus48());
      } else if (option === "bedrock/eu.anthropic.claude-opus-5") {
        return $decode.success(new BedrockClaudeOpus5());
      } else if (option === "bedrock/eu.anthropic.claude-sonnet-5") {
        return $decode.success(new BedrockClaudeSonnet5());
      } else if (option === "bedrock/deepseek.v3-v1:0") {
        return $decode.success(new BedrockDeepSeek());
      } else if (option === "gemini/gemini-2.5-flash") {
        return $decode.success(new Gemini25Flash());
      } else if (option === "gemini/gemini-2.5-pro") {
        return $decode.success(new Gemini25Pro());
      } else if (option === "gemini/gemini-3.8-flash") {
        return $decode.success(new Gemini38Flash());
      } else if (option === "gemini/gemini-3.7-flash") {
        return $decode.success(new Gemini37Flash());
      } else if (option === "gemini/gemini-3.6-flash") {
        return $decode.success(new Gemini36Flash());
      } else if (option === "gemini/gemini-3.5-flash") {
        return $decode.success(new Gemini35Flash());
      } else if (option === "gemini/gemini-3.5-flash-lite") {
        return $decode.success(new Gemini35FlashLite());
      } else if (option === "gemini/gemini-3.1-flash-lite") {
        return $decode.success(new Gemini31FlashLite());
      } else if (option === "gemini/gemini-3.1-pro-preview") {
        return $decode.success(new Gemini31ProPreview());
      } else {
        return $decode.failure(new AzureGpt4o(), expected);
      }
    },
  );
}

export function score_prompt_decoder() {
  return $decode.then$(
    $decode.string,
    (score_prompt) => {
      let expected = "compute_score_v1 | compute_score_v2";
      if (score_prompt === "compute_score_v1") {
        return $decode.success(new ComputeScoreV1());
      } else if (score_prompt === "compute_score_v2") {
        return $decode.success(new ComputeScoreV2());
      } else {
        return $decode.failure(new ComputeScoreV1(), expected);
      }
    },
  );
}

function verbosity_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "low") {
        return $decode.success(new VerbosityLow());
      } else if (value === "medium") {
        return $decode.success(new VerbosityMedium());
      } else if (value === "high") {
        return $decode.success(new VerbosityHigh());
      } else {
        return $decode.failure(new VerbosityLow(), "low | medium | high");
      }
    },
  );
}

function reasoning_effort_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "low") {
        return $decode.success(new ReasoningLow());
      } else if (value === "medium") {
        return $decode.success(new ReasoningMedium());
      } else if (value === "high") {
        return $decode.success(new ReasoningHigh());
      } else {
        return $decode.failure(new ReasoningLow(), "low | medium | high");
      }
    },
  );
}

function what_to_return_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new WhatToReturnOff());
      } else if (value === "json") {
        return $decode.success(new ReturnJson());
      } else if (value === "text") {
        return $decode.success(new ReturnText());
      } else {
        return $decode.failure(new WhatToReturnOff(), "off | json | text");
      }
    },
  );
}

function redirect_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new RedirectOff());
      } else if (value === "default") {
        return $decode.success(new RedirectDefault());
      } else {
        return $decode.failure(new RedirectOff(), "off | default");
      }
    },
  );
}

function evidence_over_assertion_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new EvidenceOverAssertionOff());
      } else if (value === "default") {
        return $decode.success(new EvidenceOverAssertionDefault());
      } else {
        return $decode.failure(new EvidenceOverAssertionOff(), "off | default");
      }
    },
  );
}

function length_rule_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new LengthRuleOff());
      } else if (value === "category_based") {
        return $decode.success(new CategoryBased());
      } else if (value === "generalistic") {
        return $decode.success(new Generalistic());
      } else {
        return $decode.failure(
          new LengthRuleOff(),
          "off | category_based | generalistic",
        );
      }
    },
  );
}

function formatting_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new FormattingOff());
      } else if (value === "default") {
        return $decode.success(new FormattingDefault());
      } else {
        return $decode.failure(new FormattingOff(), "off | default");
      }
    },
  );
}

function repeat_question_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new RepeatQuestionOff());
      } else if (value === "repeat") {
        return $decode.success(new Repeat());
      } else if (value === "do_not_repeat") {
        return $decode.success(new DoNotRepeat());
      } else if (value === "do_no_repeat") {
        return $decode.success(new DoNotRepeat());
      } else if (value === "do_not_repeat_warm") {
        return $decode.success(new DoNotRepeatWarm());
      } else {
        return $decode.failure(
          new RepeatQuestionOff(),
          "off | repeat | do_not_repeat | do_not_repeat_warm",
        );
      }
    },
  );
}

function tone_style_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new ToneStyleOff());
      } else if (value === "default") {
        return $decode.success(new ToneStyleDefault());
      } else {
        return $decode.failure(new ToneStyleOff(), "off | default");
      }
    },
  );
}

function tone_voice_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new ToneVoiceOff());
      } else if (value === "customer") {
        return $decode.success(new ToneVoiceCustomer());
      } else if (value === "engaged") {
        return $decode.success(new ToneVoiceEngaged());
      } else if (value === "generic") {
        return $decode.success(new ToneVoiceGeneric());
      } else {
        return $decode.failure(
          new ToneVoiceOff(),
          "off | customer | engaged | generic",
        );
      }
    },
  );
}

function approach_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new ApproachOff());
      } else if (value === "default") {
        return $decode.success(new ApproachDefault());
      } else {
        return $decode.failure(new ApproachOff(), "off | default");
      }
    },
  );
}

function entity_mismatch_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new EntityMismatchOff());
      } else if (value === "default") {
        return $decode.success(new EntityMismatchDefault());
      } else {
        return $decode.failure(new EntityMismatchOff(), "off | default");
      }
    },
  );
}

function role_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new RoleOff());
      } else if (value === "rfp_expert") {
        return $decode.success(new RoleRfpExpert());
      } else {
        return $decode.failure(new RoleOff(), "off | rfp_expert");
      }
    },
  );
}

function rag_modular_config_decoder() {
  return $decode.field(
    "role",
    role_decoder(),
    (role) => {
      return $decode.field(
        "entity_mismatch",
        entity_mismatch_decoder(),
        (entity_mismatch) => {
          return $decode.field(
            "approach",
            approach_decoder(),
            (approach) => {
              return $decode.field(
                "tone_voice",
                tone_voice_decoder(),
                (tone_voice) => {
                  return $decode.field(
                    "tone_style",
                    tone_style_decoder(),
                    (tone_style) => {
                      return $decode.field(
                        "repeat_or_not_question",
                        repeat_question_decoder(),
                        (repeat_or_not_question) => {
                          return $decode.field(
                            "formatting",
                            formatting_decoder(),
                            (formatting) => {
                              return $decode.field(
                                "length",
                                length_rule_decoder(),
                                (length) => {
                                  return $decode.field(
                                    "evidence_over_assertion",
                                    evidence_over_assertion_decoder(),
                                    (evidence_over_assertion) => {
                                      return $decode.field(
                                        "redirect",
                                        redirect_decoder(),
                                        (redirect) => {
                                          return $decode.field(
                                            "what_to_return",
                                            what_to_return_decoder(),
                                            (what_to_return) => {
                                              return $decode.success(
                                                new RagModularConfig(
                                                  role,
                                                  entity_mismatch,
                                                  approach,
                                                  tone_voice,
                                                  tone_style,
                                                  repeat_or_not_question,
                                                  formatting,
                                                  length,
                                                  evidence_over_assertion,
                                                  redirect,
                                                  what_to_return,
                                                ),
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function rag_prompt_decoder() {
  return $decode.then$(
    $decode.string,
    (rag_prompt) => {
      let expected = "question_answer | question_answer_v2 | assess_requirement | assess_requirement_v2 | modular";
      if (rag_prompt === "question_answer") {
        return $decode.success(new QuestionAnswerV1());
      } else if (rag_prompt === "question_answer_v2") {
        return $decode.success(new QuestionAnswerV2());
      } else if (rag_prompt === "assess_requirement") {
        return $decode.success(new AssessRequirementV1());
      } else if (rag_prompt === "assess_requirement_v2") {
        return $decode.success(new AssessRequirementV2());
      } else if (rag_prompt === "modular") {
        return $decode.success(new Modular());
      } else {
        return $decode.failure(new QuestionAnswerV1(), expected);
      }
    },
  );
}

function models_config_decoder() {
  return $decode.field(
    "rag",
    model_decoder(),
    (rag) => {
      return $decode.field(
        "rag_temperature",
        $decrypt.float(),
        (rag_temperature) => {
          return $decode.field(
            "rag_prompt",
            rag_prompt_decoder(),
            (rag_prompt) => {
              return $decrypt.optional_field(
                "rag_modular_config",
                rag_modular_config_decoder(),
                (rag_modular_config) => {
                  return $decrypt.optional_field(
                    "rag_structured_call",
                    $decode.bool,
                    (rag_structured_call) => {
                      let rag_structured_call$1 = $option.unwrap(
                        rag_structured_call,
                        true,
                      );
                      return $decrypt.optional_field(
                        "run_style_prompt",
                        $decode.bool,
                        (run_style_prompt) => {
                          return $decrypt.optional_field(
                            "convert_markdown_to_html",
                            $decode.bool,
                            (convert_markdown_to_html) => {
                              let convert_markdown_to_html$1 = $option.unwrap(
                                convert_markdown_to_html,
                                false,
                              );
                              let run_style_prompt$1 = $option.unwrap(
                                run_style_prompt,
                                true,
                              );
                              return $decrypt.optional_field(
                                "reasoning_effort",
                                reasoning_effort_decoder(),
                                (reasoning_effort) => {
                                  return $decrypt.optional_field(
                                    "verbosity",
                                    verbosity_decoder(),
                                    (verbosity) => {
                                      return $decode.field(
                                        "compute_score_prompt",
                                        score_prompt_decoder(),
                                        (compute_score_prompt) => {
                                          return $decode.field(
                                            "style_2",
                                            model_decoder(),
                                            (style_2) => {
                                              return $decode.field(
                                                "summary",
                                                model_decoder(),
                                                (summary) => {
                                                  return $decode.field(
                                                    "classifier",
                                                    model_decoder(),
                                                    (classifier) => {
                                                      return $decode.field(
                                                        "translate_model",
                                                        model_decoder(),
                                                        (translate_model) => {
                                                          return $decode.field(
                                                            "conversational_model",
                                                            model_decoder(),
                                                            (
                                                                conversational_model
                                                              ) => {
                                                              return $decode.field(
                                                                "eval_model",
                                                                model_decoder(),
                                                                (eval_model) => {
                                                                  return $decode.field(
                                                                    "website_scrapping_model",
                                                                    model_decoder(),
                                                                    (
                                                                        website_scrapping_model
                                                                      ) => {
                                                                      return $decode.field(
                                                                        "default_model",
                                                                        model_decoder(),
                                                                        (
                                                                            default_model
                                                                          ) => {
                                                                          return $decode.field(
                                                                            "search_model",
                                                                            model_decoder(),
                                                                            (
                                                                                search_model
                                                                              ) => {
                                                                              return $decrypt.optional_field(
                                                                                "rows_columns_detection_model",
                                                                                model_decoder(),
                                                                                (
                                                                                    rows_columns_detection_model
                                                                                  ) => {
                                                                                  let rows_columns_detection_model$1 = $option.unwrap(
                                                                                    rows_columns_detection_model,
                                                                                    new AzureGpt4o(),
                                                                                  );
                                                                                  return $decrypt.optional_field(
                                                                                    "advanced_cell_detection_model",
                                                                                    model_decoder(),
                                                                                    (
                                                                                        advanced_cell_detection_model
                                                                                      ) => {
                                                                                      let advanced_cell_detection_model$1 = $option.unwrap(
                                                                                        advanced_cell_detection_model,
                                                                                        new Gpt51(),
                                                                                      );
                                                                                      return $decrypt.optional_field(
                                                                                        "docx_question_detection_model",
                                                                                        model_decoder(),
                                                                                        (
                                                                                            docx_question_detection_model
                                                                                          ) => {
                                                                                          let docx_question_detection_model$1 = $option.unwrap(
                                                                                            docx_question_detection_model,
                                                                                            new Gpt41(),
                                                                                          );
                                                                                          return $decrypt.optional_field(
                                                                                            "website_capture_model",
                                                                                            model_decoder(),
                                                                                            (
                                                                                                website_capture_model
                                                                                              ) => {
                                                                                              let website_capture_model$1 = $option.unwrap(
                                                                                                website_capture_model,
                                                                                                new Gpt6Luna(),
                                                                                              );
                                                                                              return $decrypt.optional_field(
                                                                                                "answer_instruction_model",
                                                                                                model_decoder(),
                                                                                                (
                                                                                                    answer_instruction_model
                                                                                                  ) => {
                                                                                                  let answer_instruction_model$1 = $option.unwrap(
                                                                                                    answer_instruction_model,
                                                                                                    new Gpt56Luna(),
                                                                                                  );
                                                                                                  return $decrypt.optional_field(
                                                                                                    "agentic_loop_driver_model",
                                                                                                    model_decoder(),
                                                                                                    (
                                                                                                        agentic_loop_driver_model
                                                                                                      ) => {
                                                                                                      let agentic_loop_driver_model$1 = $option.unwrap(
                                                                                                        agentic_loop_driver_model,
                                                                                                        new Gpt6Luna(),
                                                                                                      );
                                                                                                      return $decode.field(
                                                                                                        "default_fallback_models",
                                                                                                        $decode.list(
                                                                                                          model_decoder(),
                                                                                                        ),
                                                                                                        (
                                                                                                            default_fallback_models
                                                                                                          ) => {
                                                                                                          return $decode.success(
                                                                                                            new ModelsConfig(
                                                                                                              rag,
                                                                                                              rag_temperature,
                                                                                                              rag_prompt,
                                                                                                              rag_modular_config,
                                                                                                              rag_structured_call$1,
                                                                                                              run_style_prompt$1,
                                                                                                              convert_markdown_to_html$1,
                                                                                                              reasoning_effort,
                                                                                                              verbosity,
                                                                                                              compute_score_prompt,
                                                                                                              style_2,
                                                                                                              summary,
                                                                                                              classifier,
                                                                                                              translate_model,
                                                                                                              conversational_model,
                                                                                                              eval_model,
                                                                                                              default_model,
                                                                                                              website_scrapping_model,
                                                                                                              search_model,
                                                                                                              rows_columns_detection_model$1,
                                                                                                              advanced_cell_detection_model$1,
                                                                                                              docx_question_detection_model$1,
                                                                                                              website_capture_model$1,
                                                                                                              answer_instruction_model$1,
                                                                                                              agentic_loop_driver_model$1,
                                                                                                              default_fallback_models,
                                                                                                            ),
                                                                                                          );
                                                                                                        },
                                                                                                      );
                                                                                                    },
                                                                                                  );
                                                                                                },
                                                                                              );
                                                                                            },
                                                                                          );
                                                                                        },
                                                                                      );
                                                                                    },
                                                                                  );
                                                                                },
                                                                              );
                                                                            },
                                                                          );
                                                                        },
                                                                      );
                                                                    },
                                                                  );
                                                                },
                                                              );
                                                            },
                                                          );
                                                        },
                                                      );
                                                    },
                                                  );
                                                },
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function llm_config_decoder() {
  return $decode.field(
    "limit",
    $decode.int,
    (limit) => { return $decode.success(new LLMConfig(limit)); },
  );
}

export function ai_system_decoder() {
  return $decode.then$(
    $decode.string,
    (ai_system) => {
      let expected = "advanced_rag | agentic_rag | llm_enhanced_vector_search";
      if (ai_system === "naive_rag") {
        return $decode.success(new NaiveRag());
      } else if (ai_system === "naive_raag") {
        return $decode.success(new NaiveRag());
      } else if (ai_system === "advanced_rag") {
        return $decode.success(new AdvancedRag());
      } else if (ai_system === "agentic_rag") {
        return $decode.success(new AgenticRag());
      } else if (ai_system === "llm_enhanced_vector_search") {
        return $decode.success(new LlmEnhancedVectorSearch());
      } else {
        return $decode.failure(new AdvancedRag(), expected);
      }
    },
  );
}

export function config_decoder() {
  let style_guidelines = $decode.optional($decode.string);
  return $decode.field(
    "style_guidelines",
    style_guidelines,
    (style_guidelines) => {
      return $decode.field(
        "ai_system",
        ai_system_decoder(),
        (ai_system) => {
          return $decode.field(
            "llm_config",
            llm_config_decoder(),
            (llm_config) => {
              return $decode.field(
                "models_config",
                models_config_decoder(),
                (models_config) => {
                  return $decode.field(
                    "query_config",
                    query_config_decoder(),
                    (query_config) => {
                      return $decode.field(
                        "retriever_config",
                        retriever_config_decoder(),
                        (retriever_config) => {
                          let pii_vocabulary = $decode.list($decode.string);
                          return $decode.field(
                            "pii_vocabulary",
                            pii_vocabulary,
                            (pii_vocabulary) => {
                              return $decrypt.optional_field(
                                "context_window",
                                context_window_decoder(),
                                (context_window) => {
                                  return $decrypt.optional_field(
                                    "llm_judge_in_the_loop",
                                    $decode.bool,
                                    (llm_judge_in_the_loop) => {
                                      return $decrypt.optional_field(
                                        "website_prompt_config",
                                        website_prompt_config_decoder(),
                                        (website_prompt_config) => {
                                          let website_prompt_config$1 = $option.unwrap(
                                            website_prompt_config,
                                            default_website_prompt_config(),
                                          );
                                          let context_window$1 = $option.unwrap(
                                            context_window,
                                            new ContextWindow(
                                              default_deactivated_context_window_lookback,
                                              default_deactivated_context_window_lookahead,
                                            ),
                                          );
                                          let llm_judge_in_the_loop$1 = $option.unwrap(
                                            llm_judge_in_the_loop,
                                            false,
                                          );
                                          return $decrypt.optional_field(
                                            "read_collection_variant",
                                            $weaviate.collection_variant_decoder(),
                                            (read_collection_variant) => {
                                              let read_collection_variant$1 = $option.unwrap(
                                                read_collection_variant,
                                                new $weaviate.Base(),
                                              );
                                              return $decrypt.optional_field(
                                                "write_collection_variant",
                                                $weaviate.collection_variant_decoder(),
                                                (write_collection_variant) => {
                                                  let write_collection_variant$1 = $option.unwrap(
                                                    write_collection_variant,
                                                    new $weaviate.Base(),
                                                  );
                                                  return $decrypt.optional_field(
                                                    "prev_write_collection_variant",
                                                    $weaviate.collection_variant_decoder(),
                                                    (
                                                        prev_write_collection_variant
                                                      ) => {
                                                      return $decode.success(
                                                        new Config(
                                                          style_guidelines,
                                                          ai_system,
                                                          llm_config,
                                                          models_config,
                                                          query_config,
                                                          retriever_config,
                                                          pii_vocabulary,
                                                          context_window$1,
                                                          llm_judge_in_the_loop$1,
                                                          website_prompt_config$1,
                                                          read_collection_variant$1,
                                                          write_collection_variant$1,
                                                          prev_write_collection_variant,
                                                        ),
                                                      );
                                                    },
                                                  );
                                                },
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function decoder() {
  return $decode.field(
    "org_id",
    $decode.string,
    (org_id) => {
      return $decode.field(
        "config",
        $decrypt.json(config_decoder()),
        (config) => { return $decode.success(new AiConfig(org_id, config)); },
      );
    },
  );
}

function encode_website_prompt_config(config) {
  return $json.object(
    toList([
      ["labels_instructions", $json.string(config.labels_instructions)],
      ["what_to_ignore", $json.string(config.what_to_ignore)],
      [
        "breadcrumbs_instructions",
        $json.string(config.breadcrumbs_instructions),
      ],
    ]),
  );
}

function encode_context_window(context_window) {
  return $json.object(
    toList([
      ["lookback", $json.int(context_window.lookback)],
      ["lookahead", $json.int(context_window.lookahead)],
    ]),
  );
}

function encode_retriever_option_type(option) {
  if (option instanceof Hybrid) {
    return $json.string("hybrid");
  } else if (option instanceof Rerank) {
    return $json.string("rerank");
  } else {
    return $json.string("fusion");
  }
}

function encode_retriever_config(retriever_config) {
  return $json.object(
    toList([["option", encode_retriever_option_type(retriever_config.option)]]),
  );
}

function encode_agentic_retrieval_config(agentic_retrieval_config) {
  return $json.object(
    toList([
      ["max_iterations", $json.int(agentic_retrieval_config.max_iterations)],
      ["max_docs", $json.int(agentic_retrieval_config.max_docs)],
      ["max_queries", $json.int(agentic_retrieval_config.max_queries)],
    ]),
  );
}

function encode_query_config(query_config) {
  return $json.object(
    toList([
      ["limit", $json.int(query_config.limit)],
      ["alpha", $json.float(query_config.alpha)],
      ["parent_lookup", $json.bool(query_config.parent_lookup)],
      ["hyde", $json.bool(query_config.hyde)],
      ["extract_question", $json.bool(query_config.extract_question)],
      ["minimal_score", $json.float(query_config.minimal_score)],
      ["split_query", $json.bool(query_config.split_query)],
      ["use_dates", $json.bool(query_config.use_dates)],
      [
        "agentic_retrieval",
        $json.nullable(
          query_config.agentic_retrieval,
          encode_agentic_retrieval_config,
        ),
      ],
    ]),
  );
}

export function model_to_string(model) {
  if (model instanceof AzureGpt4o) {
    return "azure/azure-gpt-4o";
  } else if (model instanceof AzureGpt41Mini) {
    return "azure/gpt-4.1-mini";
  } else if (model instanceof AzureGpt5Chat) {
    return "azure_ai/gpt-5-chat";
  } else if (model instanceof AzureGpt51Chat) {
    return "azure_ai/gpt-5.1-chat";
  } else if (model instanceof AzureGpt5Nano) {
    return "azure_ai/gpt-5-nano";
  } else if (model instanceof AzureLlama4Scout) {
    return "azure_ai/Llama-4-Scout-17B-16E-Instruct";
  } else if (model instanceof Gpt4o) {
    return "openai/gpt-4o";
  } else if (model instanceof Gpt41Nano) {
    return "openai/gpt-4.1-nano";
  } else if (model instanceof Gpt41Mini) {
    return "openai/gpt-4.1-mini";
  } else if (model instanceof Gpt41) {
    return "openai/gpt-4.1";
  } else if (model instanceof Gpt5Nano) {
    return "openai/gpt-5-nano";
  } else if (model instanceof Gpt5Mini) {
    return "openai/gpt-5-mini";
  } else if (model instanceof Gpt5) {
    return "openai/gpt-5";
  } else if (model instanceof Gpt5ChatLatest) {
    return "openai/gpt-5-chat-latest";
  } else if (model instanceof Gpt51) {
    return "openai/gpt-5.1";
  } else if (model instanceof Gpt51ChatLatest) {
    return "openai/gpt-5.1-chat-latest";
  } else if (model instanceof Gpt52) {
    return "openai/gpt-5.2";
  } else if (model instanceof Gpt52ChatLatest) {
    return "openai/gpt-5.2-chat-latest";
  } else if (model instanceof Gpt54Nano) {
    return "openai/gpt-5.4-nano";
  } else if (model instanceof Gpt55) {
    return "openai/gpt-5.5";
  } else if (model instanceof Gpt56Sol) {
    return "openai/gpt-5.6-sol";
  } else if (model instanceof Gpt56Terra) {
    return "openai/gpt-5.6-terra";
  } else if (model instanceof Gpt56Luna) {
    return "openai/gpt-5.6-luna";
  } else if (model instanceof Gpt6Astra) {
    return "openai/gpt-6-astra";
  } else if (model instanceof Gpt6Sol) {
    return "openai/gpt-6-sol";
  } else if (model instanceof Gpt6Luna) {
    return "openai/gpt-6-luna";
  } else if (model instanceof ClaudeHaiku45) {
    return "claude-haiku-4-5-20251001";
  } else if (model instanceof ClaudeOpus46) {
    return "claude-opus-4-6";
  } else if (model instanceof ClaudeOpus47) {
    return "claude-opus-4-7";
  } else if (model instanceof ClaudeOpus48) {
    return "claude-opus-4-8";
  } else if (model instanceof ClaudeOpus5) {
    return "claude-opus-5";
  } else if (model instanceof ClaudeSonnet46) {
    return "claude-sonnet-4-6";
  } else if (model instanceof ClaudeSonnet5) {
    return "claude-sonnet-5";
  } else if (model instanceof ClaudeFable5) {
    return "claude-fable-5";
  } else if (model instanceof ClaudeFable51) {
    return "claude-fable-5-1";
  } else if (model instanceof ClaudeOpus55) {
    return "claude-opus-5-5";
  } else if (model instanceof BedrockClaude37Sonnet) {
    return "bedrock/eu.anthropic.claude-3-7-sonnet-20250219-v1:0";
  } else if (model instanceof BedrockClaudeSonnet4) {
    return "bedrock/eu.anthropic.claude-sonnet-4-20250514-v1:0";
  } else if (model instanceof BedrockClaudeOpus45) {
    return "bedrock/eu.anthropic.claude-opus-4-5-20251101-v1:0";
  } else if (model instanceof BedrockClaudeSonnet45) {
    return "bedrock/eu.anthropic.claude-sonnet-4-5-20250929-v1:0";
  } else if (model instanceof BedrockClaudeHaiku45) {
    return "bedrock/eu.anthropic.claude-haiku-4-5-20251001-v1:0";
  } else if (model instanceof BedrockClaudeSonnet46) {
    return "bedrock/eu.anthropic.claude-sonnet-4-6";
  } else if (model instanceof BedrockClaudeOpus47) {
    return "bedrock/eu.anthropic.claude-opus-4-7";
  } else if (model instanceof BedrockClaudeOpus48) {
    return "bedrock/eu.anthropic.claude-opus-4-8";
  } else if (model instanceof BedrockClaudeOpus5) {
    return "bedrock/eu.anthropic.claude-opus-5";
  } else if (model instanceof BedrockClaudeSonnet5) {
    return "bedrock/eu.anthropic.claude-sonnet-5";
  } else if (model instanceof BedrockDeepSeek) {
    return "bedrock/deepseek.v3-v1:0";
  } else if (model instanceof Gemini25Flash) {
    return "gemini/gemini-2.5-flash";
  } else if (model instanceof Gemini25Pro) {
    return "gemini/gemini-2.5-pro";
  } else if (model instanceof Gemini38Flash) {
    return "gemini/gemini-3.8-flash";
  } else if (model instanceof Gemini37Flash) {
    return "gemini/gemini-3.7-flash";
  } else if (model instanceof Gemini36Flash) {
    return "gemini/gemini-3.6-flash";
  } else if (model instanceof Gemini35Flash) {
    return "gemini/gemini-3.5-flash";
  } else if (model instanceof Gemini35FlashLite) {
    return "gemini/gemini-3.5-flash-lite";
  } else if (model instanceof Gemini31FlashLite) {
    return "gemini/gemini-3.1-flash-lite";
  } else {
    return "gemini/gemini-3.1-pro-preview";
  }
}

export function encode_model(model) {
  let _pipe = model;
  let _pipe$1 = model_to_string(_pipe);
  return $json.string(_pipe$1);
}

function encode_score_prompt(score_prompt) {
  if (score_prompt instanceof ComputeScoreV1) {
    return $json.string("compute_score_v1");
  } else {
    return $json.string("compute_score_v2");
  }
}

function encode_verbosity(verbosity) {
  if (verbosity instanceof VerbosityLow) {
    return $json.string("low");
  } else if (verbosity instanceof VerbosityMedium) {
    return $json.string("medium");
  } else {
    return $json.string("high");
  }
}

function encode_reasoning_effort(reasoning_effort) {
  if (reasoning_effort instanceof ReasoningLow) {
    return $json.string("low");
  } else if (reasoning_effort instanceof ReasoningMedium) {
    return $json.string("medium");
  } else {
    return $json.string("high");
  }
}

function encode_what_to_return(what_to_return) {
  if (what_to_return instanceof WhatToReturnOff) {
    return $json.string("off");
  } else if (what_to_return instanceof ReturnJson) {
    return $json.string("json");
  } else {
    return $json.string("text");
  }
}

function encode_redirect(redirect) {
  if (redirect instanceof RedirectOff) {
    return $json.string("off");
  } else {
    return $json.string("default");
  }
}

function encode_evidence_over_assertion(evidence_over_assertion) {
  if (evidence_over_assertion instanceof EvidenceOverAssertionOff) {
    return $json.string("off");
  } else {
    return $json.string("default");
  }
}

function encode_length_rule(length_rule) {
  if (length_rule instanceof LengthRuleOff) {
    return $json.string("off");
  } else if (length_rule instanceof CategoryBased) {
    return $json.string("category_based");
  } else {
    return $json.string("generalistic");
  }
}

function encode_formatting(formatting) {
  if (formatting instanceof FormattingOff) {
    return $json.string("off");
  } else {
    return $json.string("default");
  }
}

function encode_repeat_question(repeat_question) {
  if (repeat_question instanceof RepeatQuestionOff) {
    return $json.string("off");
  } else if (repeat_question instanceof Repeat) {
    return $json.string("repeat");
  } else if (repeat_question instanceof DoNotRepeat) {
    return $json.string("do_not_repeat");
  } else {
    return $json.string("do_not_repeat_warm");
  }
}

function encode_tone_style(tone_style) {
  if (tone_style instanceof ToneStyleOff) {
    return $json.string("off");
  } else {
    return $json.string("default");
  }
}

function encode_tone_voice(tone_voice) {
  if (tone_voice instanceof ToneVoiceOff) {
    return $json.string("off");
  } else if (tone_voice instanceof ToneVoiceCustomer) {
    return $json.string("customer");
  } else if (tone_voice instanceof ToneVoiceEngaged) {
    return $json.string("engaged");
  } else {
    return $json.string("generic");
  }
}

function encode_approach(approach) {
  if (approach instanceof ApproachOff) {
    return $json.string("off");
  } else {
    return $json.string("default");
  }
}

function encode_entity_mismatch(entity_mismatch) {
  if (entity_mismatch instanceof EntityMismatchOff) {
    return $json.string("off");
  } else {
    return $json.string("default");
  }
}

function encode_role(role) {
  if (role instanceof RoleOff) {
    return $json.string("off");
  } else {
    return $json.string("rfp_expert");
  }
}

function encode_rag_modular_config(config) {
  return $json.object(
    toList([
      ["role", encode_role(config.role)],
      ["entity_mismatch", encode_entity_mismatch(config.entity_mismatch)],
      ["approach", encode_approach(config.approach)],
      ["tone_voice", encode_tone_voice(config.tone_voice)],
      ["tone_style", encode_tone_style(config.tone_style)],
      [
        "repeat_or_not_question",
        encode_repeat_question(config.repeat_or_not_question),
      ],
      ["formatting", encode_formatting(config.formatting)],
      ["length", encode_length_rule(config.length)],
      [
        "evidence_over_assertion",
        encode_evidence_over_assertion(config.evidence_over_assertion),
      ],
      ["redirect", encode_redirect(config.redirect)],
      ["what_to_return", encode_what_to_return(config.what_to_return)],
    ]),
  );
}

function encode_rag_prompt(rag_prompt) {
  if (rag_prompt instanceof QuestionAnswerV1) {
    return $json.string("question_answer");
  } else if (rag_prompt instanceof QuestionAnswerV2) {
    return $json.string("question_answer_v2");
  } else if (rag_prompt instanceof AssessRequirementV1) {
    return $json.string("assess_requirement");
  } else if (rag_prompt instanceof AssessRequirementV2) {
    return $json.string("assess_requirement_v2");
  } else {
    return $json.string("modular");
  }
}

function encode_models_config(models_config) {
  return $json.object(
    toList([
      ["rag", encode_model(models_config.rag)],
      ["rag_temperature", $json.float(models_config.rag_temperature)],
      ["rag_prompt", encode_rag_prompt(models_config.rag_prompt)],
      [
        "rag_modular_config",
        $json.nullable(
          models_config.rag_modular_config,
          encode_rag_modular_config,
        ),
      ],
      ["rag_structured_call", $json.bool(models_config.rag_structured_call)],
      ["run_style_prompt", $json.bool(models_config.run_style_prompt)],
      [
        "convert_markdown_to_html",
        $json.bool(models_config.convert_markdown_to_html),
      ],
      [
        "reasoning_effort",
        $json.nullable(models_config.reasoning_effort, encode_reasoning_effort),
      ],
      ["verbosity", $json.nullable(models_config.verbosity, encode_verbosity)],
      [
        "compute_score_prompt",
        encode_score_prompt(models_config.compute_score_prompt),
      ],
      ["style_2", encode_model(models_config.style_2)],
      ["summary", encode_model(models_config.summary)],
      ["classifier", encode_model(models_config.classifier)],
      ["translate_model", encode_model(models_config.translate_model)],
      ["conversational_model", encode_model(models_config.conversational_model)],
      ["eval_model", encode_model(models_config.eval_model)],
      ["default_model", encode_model(models_config.default_model)],
      [
        "website_scrapping_model",
        encode_model(models_config.website_scrapping_model),
      ],
      ["search_model", encode_model(models_config.search_model)],
      [
        "rows_columns_detection_model",
        encode_model(models_config.rows_columns_detection_model),
      ],
      [
        "advanced_cell_detection_model",
        encode_model(models_config.advanced_cell_detection_model),
      ],
      [
        "docx_question_detection_model",
        encode_model(models_config.docx_question_detection_model),
      ],
      [
        "website_capture_model",
        encode_model(models_config.website_capture_model),
      ],
      [
        "answer_instruction_model",
        encode_model(models_config.answer_instruction_model),
      ],
      [
        "agentic_loop_driver_model",
        encode_model(models_config.agentic_loop_driver_model),
      ],
      [
        "default_fallback_models",
        $json.array(models_config.default_fallback_models, encode_model),
      ],
    ]),
  );
}

function encode_llm_config(llm_config) {
  return $json.object(toList([["limit", $json.int(llm_config.limit)]]));
}

function encode_ai_system(ai_system) {
  if (ai_system instanceof NaiveRag) {
    return $json.string("naive_rag");
  } else if (ai_system instanceof AdvancedRag) {
    return $json.string("advanced_rag");
  } else if (ai_system instanceof AgenticRag) {
    return $json.string("agentic_rag");
  } else {
    return $json.string("llm_enhanced_vector_search");
  }
}

export function encode_config(config) {
  return $json.object(
    toList([
      [
        "style_guidelines",
        $json.nullable(config.style_guidelines, $json.string),
      ],
      ["ai_system", encode_ai_system(config.ai_system)],
      ["llm_config", encode_llm_config(config.llm_config)],
      ["models_config", encode_models_config(config.models_config)],
      ["query_config", encode_query_config(config.query_config)],
      ["retriever_config", encode_retriever_config(config.retriever_config)],
      ["pii_vocabulary", $json.array(config.pii_vocabulary, $json.string)],
      ["context_window", encode_context_window(config.context_window)],
      ["llm_judge_in_the_loop", $json.bool(config.llm_judge_in_the_loop)],
      [
        "website_prompt_config",
        encode_website_prompt_config(config.website_prompt_config),
      ],
      [
        "read_collection_variant",
        $weaviate.encode_collection_variant(config.read_collection_variant),
      ],
      [
        "write_collection_variant",
        $weaviate.encode_collection_variant(config.write_collection_variant),
      ],
      [
        "prev_write_collection_variant",
        $json.nullable(
          config.prev_write_collection_variant,
          $weaviate.encode_collection_variant,
        ),
      ],
    ]),
  );
}

export function encode(ai_config) {
  return $json.object(
    toList([
      ["org_id", $json.string(ai_config.org_id)],
      ["config", encode_config(ai_config.config)],
    ]),
  );
}

function default_rag_modular_config() {
  return new RagModularConfig(
    new RoleRfpExpert(),
    new EntityMismatchDefault(),
    new ApproachDefault(),
    new ToneVoiceCustomer(),
    new ToneStyleDefault(),
    new DoNotRepeat(),
    new FormattingDefault(),
    new CategoryBased(),
    new EvidenceOverAssertionDefault(),
    new RedirectDefault(),
    new ReturnJson(),
  );
}

export function default_config() {
  let retriever_config = new RetrieverConfig(new Hybrid());
  let query_config = new QueryConfig(
    50,
    0.5,
    false,
    false,
    false,
    0.0,
    false,
    false,
    new Some(new AgenticRetrievalConfig(3, 10, 3)),
  );
  let models_config = new ModelsConfig(
    new Gpt6Astra(),
    0.0,
    new Modular(),
    new Some(default_rag_modular_config()),
    true,
    true,
    true,
    new Some(new ReasoningLow()),
    new Some(new VerbosityLow()),
    new ComputeScoreV2(),
    new Gpt41Mini(),
    new Gpt41Mini(),
    new Gpt41Mini(),
    new Gpt6Luna(),
    new Gpt6Luna(),
    new Gpt51(),
    new Gpt6Sol(),
    new Gpt6Luna(),
    new Gpt6Luna(),
    new Gpt6Sol(),
    new Gpt55(),
    new Gpt55(),
    new Gpt6Luna(),
    new Gpt56Luna(),
    new Gpt6Luna(),
    toList([new Gpt51(), new Gpt41Mini()]),
  );
  let llm_config = new LLMConfig(10);
  return new Config(
    new Some(""),
    new AdvancedRag(),
    llm_config,
    models_config,
    query_config,
    retriever_config,
    toList([]),
    new ContextWindow(
      default_deactivated_context_window_lookback,
      default_deactivated_context_window_lookahead,
    ),
    false,
    default_website_prompt_config(),
    new $weaviate.Base(),
    new $weaviate.Base(),
    new $option.None(),
  );
}

export function set_website_prompt_config(ai_config, website_prompt_config) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_ai_system(ai_config, ai_system) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        ai_system,
        _record.llm_config,
        _record.models_config,
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_rag_prompt(ai_config, rag_prompt) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let _record$1 = ai_config.config.models_config;
          return new ModelsConfig(
            _record$1.rag,
            _record$1.rag_temperature,
            rag_prompt,
            _record$1.rag_modular_config,
            _record$1.rag_structured_call,
            _record$1.run_style_prompt,
            _record$1.convert_markdown_to_html,
            _record$1.reasoning_effort,
            _record$1.verbosity,
            _record$1.compute_score_prompt,
            _record$1.style_2,
            _record$1.summary,
            _record$1.classifier,
            _record$1.translate_model,
            _record$1.conversational_model,
            _record$1.eval_model,
            _record$1.default_model,
            _record$1.website_scrapping_model,
            _record$1.search_model,
            _record$1.rows_columns_detection_model,
            _record$1.advanced_cell_detection_model,
            _record$1.docx_question_detection_model,
            _record$1.website_capture_model,
            _record$1.answer_instruction_model,
            _record$1.agentic_loop_driver_model,
            _record$1.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_rag_model(ai_config, rag) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_search_model(ai_config, search_model) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_rows_columns_detection_model(
  ai_config,
  rows_columns_detection_model
) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_advanced_cell_detection_model(
  ai_config,
  advanced_cell_detection_model
) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_docx_question_detection_model(
  ai_config,
  docx_question_detection_model
) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_website_capture_model(ai_config, website_capture_model) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

/**
 * Model that writes the per-column answer instruction when a header is
 * confirmed at labelling time.
 */
export function set_answer_instruction_model(
  ai_config,
  answer_instruction_model
) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

/**
 * Model that drives the agentic RAG tool loop. The final answer is still
 * written by the rag model.
 */
export function set_agentic_loop_driver_model(
  ai_config,
  agentic_loop_driver_model
) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_score_prompt(ai_config, compute_score_prompt) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

function parse_float(value) {
  let number = $float.parse(value);
  return $result.lazy_or(
    number,
    () => {
      return $result.map(
        $int.parse(value),
        (number) => { return $int.to_float(number); },
      );
    },
  );
}

export function set_minimal_score(ai_config, minimal_score) {
  let $ = parse_float(minimal_score);
  if ($ instanceof Ok) {
    let minimal_score$1 = $[0];
    return new AiConfig(
      ai_config.org_id,
      (() => {
        let _record = ai_config.config;
        return new Config(
          _record.style_guidelines,
          _record.ai_system,
          _record.llm_config,
          _record.models_config,
          (() => {
            let _record$1 = ai_config.config.query_config;
            return new QueryConfig(
              _record$1.limit,
              _record$1.alpha,
              _record$1.parent_lookup,
              _record$1.hyde,
              _record$1.extract_question,
              minimal_score$1,
              _record$1.split_query,
              _record$1.use_dates,
              _record$1.agentic_retrieval,
            );
          })(),
          _record.retriever_config,
          _record.pii_vocabulary,
          _record.context_window,
          _record.llm_judge_in_the_loop,
          _record.website_prompt_config,
          _record.read_collection_variant,
          _record.write_collection_variant,
          _record.prev_write_collection_variant,
        );
      })(),
    );
  } else {
    return ai_config;
  }
}

export function toggle_split_query(ai_config) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        (() => {
          let _record$1 = ai_config.config.query_config;
          return new QueryConfig(
            _record$1.limit,
            _record$1.alpha,
            _record$1.parent_lookup,
            _record$1.hyde,
            _record$1.extract_question,
            _record$1.minimal_score,
            !ai_config.config.query_config.split_query,
            _record$1.use_dates,
            _record$1.agentic_retrieval,
          );
        })(),
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function toggle_use_dates(ai_config) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        (() => {
          let _record$1 = ai_config.config.query_config;
          return new QueryConfig(
            _record$1.limit,
            _record$1.alpha,
            _record$1.parent_lookup,
            _record$1.hyde,
            _record$1.extract_question,
            _record$1.minimal_score,
            _record$1.split_query,
            !ai_config.config.query_config.use_dates,
            _record$1.agentic_retrieval,
          );
        })(),
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_query_limit(ai_config, query_limit) {
  let $ = $int.parse(query_limit);
  if ($ instanceof Ok) {
    let limit = $[0];
    return new AiConfig(
      ai_config.org_id,
      (() => {
        let _record = ai_config.config;
        return new Config(
          _record.style_guidelines,
          _record.ai_system,
          _record.llm_config,
          _record.models_config,
          (() => {
            let _record$1 = ai_config.config.query_config;
            return new QueryConfig(
              limit,
              _record$1.alpha,
              _record$1.parent_lookup,
              _record$1.hyde,
              _record$1.extract_question,
              _record$1.minimal_score,
              _record$1.split_query,
              _record$1.use_dates,
              _record$1.agentic_retrieval,
            );
          })(),
          _record.retriever_config,
          _record.pii_vocabulary,
          _record.context_window,
          _record.llm_judge_in_the_loop,
          _record.website_prompt_config,
          _record.read_collection_variant,
          _record.write_collection_variant,
          _record.prev_write_collection_variant,
        );
      })(),
    );
  } else {
    return ai_config;
  }
}

export function set_llm_limit(ai_config, llm_limit) {
  let $ = $int.parse(llm_limit);
  if ($ instanceof Ok) {
    let limit = $[0];
    return new AiConfig(
      ai_config.org_id,
      (() => {
        let _record = ai_config.config;
        return new Config(
          _record.style_guidelines,
          _record.ai_system,
          new LLMConfig(limit),
          _record.models_config,
          _record.query_config,
          _record.retriever_config,
          _record.pii_vocabulary,
          _record.context_window,
          _record.llm_judge_in_the_loop,
          _record.website_prompt_config,
          _record.read_collection_variant,
          _record.write_collection_variant,
          _record.prev_write_collection_variant,
        );
      })(),
    );
  } else {
    return ai_config;
  }
}

export function set_retriever_option(ai_config, option) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        _record.query_config,
        new RetrieverConfig(option),
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_query_alpha(ai_config, alpha) {
  let $ = parse_float(alpha);
  if ($ instanceof Ok) {
    let alpha$1 = $[0];
    return new AiConfig(
      ai_config.org_id,
      (() => {
        let _record = ai_config.config;
        return new Config(
          _record.style_guidelines,
          _record.ai_system,
          _record.llm_config,
          _record.models_config,
          (() => {
            let _record$1 = ai_config.config.query_config;
            return new QueryConfig(
              _record$1.limit,
              alpha$1,
              _record$1.parent_lookup,
              _record$1.hyde,
              _record$1.extract_question,
              _record$1.minimal_score,
              _record$1.split_query,
              _record$1.use_dates,
              _record$1.agentic_retrieval,
            );
          })(),
          _record.retriever_config,
          _record.pii_vocabulary,
          _record.context_window,
          _record.llm_judge_in_the_loop,
          _record.website_prompt_config,
          _record.read_collection_variant,
          _record.write_collection_variant,
          _record.prev_write_collection_variant,
        );
      })(),
    );
  } else {
    return ai_config;
  }
}

export function toggle_agentic_retrieval_config(ai_config) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        (() => {
          let query_config = ai_config.config.query_config;
          let retrieval = ai_config.config.query_config.agentic_retrieval;
          return new QueryConfig(
            query_config.limit,
            query_config.alpha,
            query_config.parent_lookup,
            query_config.hyde,
            query_config.extract_question,
            query_config.minimal_score,
            query_config.split_query,
            query_config.use_dates,
            (() => {
              if (retrieval instanceof Some) {
                return new None();
              } else {
                return new Some(new AgenticRetrievalConfig(5, 10, 3));
              }
            })(),
          );
        })(),
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_agentic_retrieval_max_iterations(ai_config, max_iterations) {
  let $ = $int.parse(max_iterations);
  if ($ instanceof Ok) {
    let max_iterations$1 = $[0];
    return new AiConfig(
      ai_config.org_id,
      (() => {
        let _record = ai_config.config;
        return new Config(
          _record.style_guidelines,
          _record.ai_system,
          _record.llm_config,
          _record.models_config,
          (() => {
            let query_config = ai_config.config.query_config;
            let retrieval = ai_config.config.query_config.agentic_retrieval;
            return new QueryConfig(
              query_config.limit,
              query_config.alpha,
              query_config.parent_lookup,
              query_config.hyde,
              query_config.extract_question,
              query_config.minimal_score,
              query_config.split_query,
              query_config.use_dates,
              $option.map(
                retrieval,
                (agentic_retrieval) => {
                  return new AgenticRetrievalConfig(
                    max_iterations$1,
                    agentic_retrieval.max_docs,
                    agentic_retrieval.max_queries,
                  );
                },
              ),
            );
          })(),
          _record.retriever_config,
          _record.pii_vocabulary,
          _record.context_window,
          _record.llm_judge_in_the_loop,
          _record.website_prompt_config,
          _record.read_collection_variant,
          _record.write_collection_variant,
          _record.prev_write_collection_variant,
        );
      })(),
    );
  } else {
    return ai_config;
  }
}

export function set_agentic_retrieval_max_docs(ai_config, max_docs) {
  let $ = $int.parse(max_docs);
  if ($ instanceof Ok) {
    let max_docs$1 = $[0];
    return new AiConfig(
      ai_config.org_id,
      (() => {
        let _record = ai_config.config;
        return new Config(
          _record.style_guidelines,
          _record.ai_system,
          _record.llm_config,
          _record.models_config,
          (() => {
            let retrieval = ai_config.config.query_config.agentic_retrieval;
            let query_config = ai_config.config.query_config;
            return new QueryConfig(
              query_config.limit,
              query_config.alpha,
              query_config.parent_lookup,
              query_config.hyde,
              query_config.extract_question,
              query_config.minimal_score,
              query_config.split_query,
              query_config.use_dates,
              $option.map(
                retrieval,
                (agentic_retrieval) => {
                  return new AgenticRetrievalConfig(
                    agentic_retrieval.max_iterations,
                    max_docs$1,
                    agentic_retrieval.max_queries,
                  );
                },
              ),
            );
          })(),
          _record.retriever_config,
          _record.pii_vocabulary,
          _record.context_window,
          _record.llm_judge_in_the_loop,
          _record.website_prompt_config,
          _record.read_collection_variant,
          _record.write_collection_variant,
          _record.prev_write_collection_variant,
        );
      })(),
    );
  } else {
    return ai_config;
  }
}

export function set_agentic_retrieval_max_queries(ai_config, max_queries) {
  let $ = $int.parse(max_queries);
  if ($ instanceof Ok) {
    let max_queries$1 = $[0];
    return new AiConfig(
      ai_config.org_id,
      (() => {
        let _record = ai_config.config;
        return new Config(
          _record.style_guidelines,
          _record.ai_system,
          _record.llm_config,
          _record.models_config,
          (() => {
            let query_config = ai_config.config.query_config;
            let retrieval = ai_config.config.query_config.agentic_retrieval;
            return new QueryConfig(
              query_config.limit,
              query_config.alpha,
              query_config.parent_lookup,
              query_config.hyde,
              query_config.extract_question,
              query_config.minimal_score,
              query_config.split_query,
              query_config.use_dates,
              $option.map(
                retrieval,
                (agentic_retrieval) => {
                  return new AgenticRetrievalConfig(
                    agentic_retrieval.max_iterations,
                    agentic_retrieval.max_docs,
                    max_queries$1,
                  );
                },
              ),
            );
          })(),
          _record.retriever_config,
          _record.pii_vocabulary,
          _record.context_window,
          _record.llm_judge_in_the_loop,
          _record.website_prompt_config,
          _record.read_collection_variant,
          _record.write_collection_variant,
          _record.prev_write_collection_variant,
        );
      })(),
    );
  } else {
    return ai_config;
  }
}

export function set_read_collection_variant(ai_config, read_collection_variant) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_write_collection_variant(
  ai_config,
  write_collection_variant
) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_prev_write_collection_variant(
  ai_config,
  prev_write_collection_variant
) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        prev_write_collection_variant,
      );
    })(),
  );
}

export function set_default_model(ai_config, default_model) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let _record$1 = ai_config.config.models_config;
          return new ModelsConfig(
            _record$1.rag,
            _record$1.rag_temperature,
            _record$1.rag_prompt,
            _record$1.rag_modular_config,
            _record$1.rag_structured_call,
            _record$1.run_style_prompt,
            _record$1.convert_markdown_to_html,
            _record$1.reasoning_effort,
            _record$1.verbosity,
            _record$1.compute_score_prompt,
            _record$1.style_2,
            _record$1.summary,
            _record$1.classifier,
            _record$1.translate_model,
            _record$1.conversational_model,
            _record$1.eval_model,
            default_model,
            _record$1.website_scrapping_model,
            _record$1.search_model,
            _record$1.rows_columns_detection_model,
            _record$1.advanced_cell_detection_model,
            _record$1.docx_question_detection_model,
            _record$1.website_capture_model,
            _record$1.answer_instruction_model,
            _record$1.agentic_loop_driver_model,
            _record$1.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_website_scrapping_model(ai_config, website_scrapping_model) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let _record$1 = ai_config.config.models_config;
          return new ModelsConfig(
            _record$1.rag,
            _record$1.rag_temperature,
            _record$1.rag_prompt,
            _record$1.rag_modular_config,
            _record$1.rag_structured_call,
            _record$1.run_style_prompt,
            _record$1.convert_markdown_to_html,
            _record$1.reasoning_effort,
            _record$1.verbosity,
            _record$1.compute_score_prompt,
            _record$1.style_2,
            _record$1.summary,
            _record$1.classifier,
            _record$1.translate_model,
            _record$1.conversational_model,
            _record$1.eval_model,
            _record$1.default_model,
            website_scrapping_model,
            _record$1.search_model,
            _record$1.rows_columns_detection_model,
            _record$1.advanced_cell_detection_model,
            _record$1.docx_question_detection_model,
            _record$1.website_capture_model,
            _record$1.answer_instruction_model,
            _record$1.agentic_loop_driver_model,
            _record$1.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_translate_model(ai_config, translate_model) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_conversational_model(ai_config, conversational_model) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_pii_vocabulary_in_ai_config(ai_config, pii_vocabulary) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        _record.query_config,
        _record.retriever_config,
        pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_rag_structured_call(ai_config, rag_structured_call) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let _record$1 = ai_config.config.models_config;
          return new ModelsConfig(
            _record$1.rag,
            _record$1.rag_temperature,
            _record$1.rag_prompt,
            _record$1.rag_modular_config,
            rag_structured_call,
            _record$1.run_style_prompt,
            _record$1.convert_markdown_to_html,
            _record$1.reasoning_effort,
            _record$1.verbosity,
            _record$1.compute_score_prompt,
            _record$1.style_2,
            _record$1.summary,
            _record$1.classifier,
            _record$1.translate_model,
            _record$1.conversational_model,
            _record$1.eval_model,
            _record$1.default_model,
            _record$1.website_scrapping_model,
            _record$1.search_model,
            _record$1.rows_columns_detection_model,
            _record$1.advanced_cell_detection_model,
            _record$1.docx_question_detection_model,
            _record$1.website_capture_model,
            _record$1.answer_instruction_model,
            _record$1.agentic_loop_driver_model,
            _record$1.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_run_style_prompt(ai_config, run_style_prompt) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let _record$1 = ai_config.config.models_config;
          return new ModelsConfig(
            _record$1.rag,
            _record$1.rag_temperature,
            _record$1.rag_prompt,
            _record$1.rag_modular_config,
            _record$1.rag_structured_call,
            run_style_prompt,
            _record$1.convert_markdown_to_html,
            _record$1.reasoning_effort,
            _record$1.verbosity,
            _record$1.compute_score_prompt,
            _record$1.style_2,
            _record$1.summary,
            _record$1.classifier,
            _record$1.translate_model,
            _record$1.conversational_model,
            _record$1.eval_model,
            _record$1.default_model,
            _record$1.website_scrapping_model,
            _record$1.search_model,
            _record$1.rows_columns_detection_model,
            _record$1.advanced_cell_detection_model,
            _record$1.docx_question_detection_model,
            _record$1.website_capture_model,
            _record$1.answer_instruction_model,
            _record$1.agentic_loop_driver_model,
            _record$1.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_convert_markdown_to_html(
  ai_config,
  convert_markdown_to_html
) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let _record$1 = ai_config.config.models_config;
          return new ModelsConfig(
            _record$1.rag,
            _record$1.rag_temperature,
            _record$1.rag_prompt,
            _record$1.rag_modular_config,
            _record$1.rag_structured_call,
            _record$1.run_style_prompt,
            convert_markdown_to_html,
            _record$1.reasoning_effort,
            _record$1.verbosity,
            _record$1.compute_score_prompt,
            _record$1.style_2,
            _record$1.summary,
            _record$1.classifier,
            _record$1.translate_model,
            _record$1.conversational_model,
            _record$1.eval_model,
            _record$1.default_model,
            _record$1.website_scrapping_model,
            _record$1.search_model,
            _record$1.rows_columns_detection_model,
            _record$1.advanced_cell_detection_model,
            _record$1.docx_question_detection_model,
            _record$1.website_capture_model,
            _record$1.answer_instruction_model,
            _record$1.agentic_loop_driver_model,
            _record$1.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_llm_judge_in_the_loop(ai_config, llm_judge_in_the_loop) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_reasoning_effort(ai_config, reasoning_effort) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let _record$1 = ai_config.config.models_config;
          return new ModelsConfig(
            _record$1.rag,
            _record$1.rag_temperature,
            _record$1.rag_prompt,
            _record$1.rag_modular_config,
            _record$1.rag_structured_call,
            _record$1.run_style_prompt,
            _record$1.convert_markdown_to_html,
            reasoning_effort,
            _record$1.verbosity,
            _record$1.compute_score_prompt,
            _record$1.style_2,
            _record$1.summary,
            _record$1.classifier,
            _record$1.translate_model,
            _record$1.conversational_model,
            _record$1.eval_model,
            _record$1.default_model,
            _record$1.website_scrapping_model,
            _record$1.search_model,
            _record$1.rows_columns_detection_model,
            _record$1.advanced_cell_detection_model,
            _record$1.docx_question_detection_model,
            _record$1.website_capture_model,
            _record$1.answer_instruction_model,
            _record$1.agentic_loop_driver_model,
            _record$1.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_verbosity(ai_config, verbosity) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let _record$1 = ai_config.config.models_config;
          return new ModelsConfig(
            _record$1.rag,
            _record$1.rag_temperature,
            _record$1.rag_prompt,
            _record$1.rag_modular_config,
            _record$1.rag_structured_call,
            _record$1.run_style_prompt,
            _record$1.convert_markdown_to_html,
            _record$1.reasoning_effort,
            verbosity,
            _record$1.compute_score_prompt,
            _record$1.style_2,
            _record$1.summary,
            _record$1.classifier,
            _record$1.translate_model,
            _record$1.conversational_model,
            _record$1.eval_model,
            _record$1.default_model,
            _record$1.website_scrapping_model,
            _record$1.search_model,
            _record$1.rows_columns_detection_model,
            _record$1.advanced_cell_detection_model,
            _record$1.docx_question_detection_model,
            _record$1.website_capture_model,
            _record$1.answer_instruction_model,
            _record$1.agentic_loop_driver_model,
            _record$1.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_context_window(ai_config, lookback, lookahead) {
  let $ = $int.parse(lookback);
  let $1 = $int.parse(lookahead);
  if ($ instanceof Ok && $1 instanceof Ok) {
    let lookback$1 = $[0];
    let lookahead$1 = $1[0];
    return new AiConfig(
      ai_config.org_id,
      (() => {
        let _record = ai_config.config;
        return new Config(
          _record.style_guidelines,
          _record.ai_system,
          _record.llm_config,
          _record.models_config,
          _record.query_config,
          _record.retriever_config,
          _record.pii_vocabulary,
          new ContextWindow(lookback$1, lookahead$1),
          _record.llm_judge_in_the_loop,
          _record.website_prompt_config,
          _record.read_collection_variant,
          _record.write_collection_variant,
          _record.prev_write_collection_variant,
        );
      })(),
    );
  } else {
    return ai_config;
  }
}

export function toggle_rag_modular_config(ai_config) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          let _block;
          let $ = models_config.rag_modular_config;
          if ($ instanceof Some) {
            _block = new None();
          } else {
            _block = new Some(default_rag_modular_config());
          }
          let rag_modular_config = _block;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

function update_rag_modular_config(ai_config, updater) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          let rag_modular_config = $option.map(
            models_config.rag_modular_config,
            updater,
          );
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_rag_modular_role(ai_config, role) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        role,
        c.entity_mismatch,
        c.approach,
        c.tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        c.formatting,
        c.length,
        c.evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_entity_mismatch(ai_config, entity_mismatch) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        entity_mismatch,
        c.approach,
        c.tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        c.formatting,
        c.length,
        c.evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_approach(ai_config, approach) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        approach,
        c.tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        c.formatting,
        c.length,
        c.evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_tone_voice(ai_config, tone_voice) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        c.approach,
        tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        c.formatting,
        c.length,
        c.evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_tone_style(ai_config, tone_style) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        c.approach,
        c.tone_voice,
        tone_style,
        c.repeat_or_not_question,
        c.formatting,
        c.length,
        c.evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_repeat_question(
  ai_config,
  repeat_or_not_question
) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        c.approach,
        c.tone_voice,
        c.tone_style,
        repeat_or_not_question,
        c.formatting,
        c.length,
        c.evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_formatting(ai_config, formatting) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        c.approach,
        c.tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        formatting,
        c.length,
        c.evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_length(ai_config, length) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        c.approach,
        c.tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        c.formatting,
        length,
        c.evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_evidence_over_assertion(
  ai_config,
  evidence_over_assertion
) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        c.approach,
        c.tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        c.formatting,
        c.length,
        evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_redirect(ai_config, redirect) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        c.approach,
        c.tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        c.formatting,
        c.length,
        c.evidence_over_assertion,
        redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_what_to_return(ai_config, what_to_return) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        c.approach,
        c.tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        c.formatting,
        c.length,
        c.evidence_over_assertion,
        c.redirect,
        what_to_return,
      );
    },
  );
}
